/**
 * 500 Additional High-Quality Puzzles
 * 
 * ✅ Popularity > 95
 * ✅ Material validated
 * ✅ Distributed across: Tactics, Strategy, Opening, Checkmate
 */

import { ChessPuzzle } from '../services/chessPuzzleService';

export const ADDITIONAL_500_PUZZLES: Omit<ChessPuzzle, 'id' | 'createdAt' | 'createdBy' | 'source'>[] = [
    {
        fen: "2r3k1/p2q1pbp/1p2pnp1/nB1p4/3P4/1Pr1P2P/P1QB1PP1/2R2RK1 w - - 0 19",
        moves: "b5d7 c3c2 d7c8 c2d2",
        rating: 1715,
        themes: ["advantage", "middlegame", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1715)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "4B1k1/2p2p1p/1p1p1P1K/p2P2P1/2P5/1P6/8/2n5 b - - 4 39",
        moves: "c1b3 e8f7 g8f7 h6h7 b3d2 g5g6 f7f6 g6g7",
        rating: 1488,
        themes: ["advancedPawn", "advantage", "deflection", "endgame", "sacrifice", "veryLong"],
        description: "Intermediate Tactics - Play as Black (Rating: 1488)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r5k1/p3prb1/4Bnp1/3p3P/q1nP1B2/1p2PPN1/PRp4R/K3Q3 w - - 1 26",
        moves: "h5g6 c4b2 g6f7 g8f8 a1b2 a4a2",
        rating: 1393,
        themes: ["advantage", "long", "middlegame", "sacrifice"],
        description: "Intermediate Tactics - Play as White (Rating: 1393)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2q1rk1/5p1R/ppb1p1p1/n7/P2P1B2/2PB4/5PPP/1R1Q2K1 b - - 0 19",
        moves: "g8h7 d1h5 h7g8 d3g6 f7g6 h5g6",
        rating: 1653,
        themes: ["crushing", "deflection", "long", "middlegame", "pin"],
        description: "Advanced Tactics - Play as Black - Pin (Rating: 1653)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "1R6/1P6/5p2/5kp1/5P2/1r4P1/4K3/8 b - - 0 47",
        moves: "g5f4 g3g4 f5g4 b8g8",
        rating: 1653,
        themes: ["attraction", "crushing", "endgame", "master", "rookEndgame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1653)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b1k2r/p1pp1pp1/1p5p/2b1P3/4QB2/2N3P1/PPP5/R3KBq1 w Qkq - 0 13",
        moves: "e4a8 g1f2 e1d1 f2f1",
        rating: 1084,
        themes: ["advantage", "deflection", "master", "middlegame", "short"],
        description: "Beginner Tactics - Play as White (Rating: 1084)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "r7/4kpp1/p4q2/1p1ppP2/2n5/1Br4P/P5P1/3QRRK1 b - - 3 28",
        moves: "c4e3 e1e3 c3e3 d1d5 a8d8 d5c5",
        rating: 1673,
        themes: ["advantage", "capturingDefender", "long", "middlegame"],
        description: "Advanced Tactics - Play as Black (Rating: 1673)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2r3k/pp2bppp/q3p3/4R1B1/4n2Q/5P2/PPP2P1P/1K4R1 w - - 0 18",
        moves: "g5e7 e4d2 b1a1 d2f3",
        rating: 1700,
        themes: ["advantage", "middlegame", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1700)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2q1r2/1b3pkp/1p1p1Np1/pPn5/2P1P3/P7/4B1PP/R2Q1RK1 b - - 0 21",
        moves: "c5e4 f6e4 b7e4 d1d4",
        rating: 1385,
        themes: ["crushing", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1385)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5rk1/2Q1Rbp1/5p2/3q3p/7P/6P1/4BP2/6K1 b - - 1 38",
        moves: "d5b3 e7f7 b3f7 e2c4",
        rating: 1476,
        themes: ["advantage", "endgame", "pin", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1476)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "3rr2k/5p1p/p4p2/1p3P2/2np1B2/PB1R4/1PP1N2P/6K1 w - - 2 32",
        moves: "d3d4 d8d4 e2d4 e8e4",
        rating: 1798,
        themes: ["advantage", "middlegame", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1798)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "3r1q1r/ppN2kbQ/3p2p1/2p1n3/2P1P3/4BP1B/PP6/2KR3R b - - 5 23",
        moves: "h8h7 h3e6 f7f6 h1h7",
        rating: 1396,
        themes: ["advantage", "discoveredAttack", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1396)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5k2/5pp1/1N5r/q4b1p/7P/2Q2PP1/P3K3/1B1R3R b - - 0 33",
        moves: "a5c3 d1d8 f8e7 b6d5 e7d8 d5c3",
        rating: 1440,
        themes: ["advantage", "fork", "long", "middlegame"],
        description: "Intermediate Tactics - Play as Black - Fork (Rating: 1440)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5rk1/ppr2pp1/4b2p/4q3/3bN3/P5P1/1P1Q1PBP/3R1RK1 b - - 5 19",
        moves: "d4b2 f2f4 e5b5 d1b1",
        rating: 1742,
        themes: ["advantage", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1742)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "4k3/5pp1/p2qp1p1/1p1p3r/2rP4/1Q3PP1/PP5n/1K2RN1R w - - 1 23",
        moves: "h1h2 h5h2 f1h2 d6g3 e1h1 g3g2",
        rating: 1582,
        themes: ["crushing", "fork", "long", "middlegame"],
        description: "Intermediate Tactics - Play as White - Fork (Rating: 1582)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "4Q3/pp2b1rk/4p1B1/8/1nPP3P/q7/3R4/5K2 b - - 1 41",
        moves: "h7h6 e8h8 h6g6 d2g2",
        rating: 1138,
        themes: ["advantage", "middlegame", "sacrifice", "short"],
        description: "Beginner Tactics - Play as Black (Rating: 1138)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2qk2r/pp3ppp/4p3/3Pn3/8/8/P1P2PPP/R1BQ1RK1 b kq - 0 13",
        moves: "d8d5 d1d5 e6d5 f1e1 f7f6 f2f4",
        rating: 1754,
        themes: ["crushing", "long", "middlegame", "pin"],
        description: "Advanced Tactics - Play as Black - Pin (Rating: 1754)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "k5r1/p7/2p5/3p1p1p/3PqB2/2P4P/5QP1/2R3K1 w - - 0 33",
        moves: "g1h2 g8g2 f2g2 e4f4",
        rating: 1216,
        themes: ["crushing", "deflection", "endgame", "fork", "master", "short"],
        description: "Intermediate Tactics - Play as White - Fork (Rating: 1216)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1bq1rk1/ppp2p2/3p2pQ/4p1p1/3bP1P1/2NB4/PPP3PP/R3K2R b KQ - 1 13",
        moves: "d8f6 c3d5 f6f2 e1d1 c8g4 d1c1",
        rating: 1271,
        themes: ["advantage", "long", "middlegame"],
        description: "Intermediate Tactics - Play as Black (Rating: 1271)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4rk1/pbp2ppp/1pq1p2R/8/2P4P/P2B4/2PKN3/6QR b - - 2 18",
        moves: "c6h1 d3h7 g8h8 h7e4",
        rating: 1394,
        themes: ["advantage", "discoveredAttack", "discoveredCheck", "kingsideAttack", "middlegame", "pin", "short"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1394)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5qk1/pp2bp2/6pp/8/3QB1r1/1P5b/P1R2PPP/5RK1 w - - 1 24",
        moves: "f2f3 g4g2 c2g2 e7c5",
        rating: 1697,
        themes: ["advantage", "middlegame", "pin", "sacrifice", "short"],
        description: "Advanced Tactics - Play as White - Pin (Rating: 1697)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4rk1/ppp1n1pp/5n2/3Pp3/2P5/3B2Nq/PBQ2P2/R4RK1 w - - 0 19",
        moves: "b2e5 f6g4 d3h7 g8h8",
        rating: 1631,
        themes: ["advantage", "defensiveMove", "middlegame", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1631)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "rn2k2r/pbp2Npp/1p6/3p4/3Pp3/6q1/PPP5/RNBQ1R1K b kq - 1 13",
        moves: "e8g8 f7h6 g7h6 f1g1",
        rating: 1440,
        themes: ["advantage", "middlegame", "pin", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1440)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r6k/pp3p1p/3p4/2p2R1P/2Pb3q/3P1QrP/P5B1/1RB4K w - - 6 21",
        moves: "f3f4 g3h3 g2h3 h4h3",
        rating: 1624,
        themes: ["crushing", "kingsideAttack", "master", "middlegame", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1624)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r6r/4kpp1/p3qn2/2Qp4/4p3/4P1Pp/PPPR1P1N/3R2K1 b - - 0 22",
        moves: "e7d7 d2d5 f6d5 d1d5 d7e8 d5e5",
        rating: 1282,
        themes: ["crushing", "exposedKing", "long", "middlegame", "pin"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1282)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2rkr3/6pp/1p1p1b2/Q2Pp3/4N2P/3b4/PB6/K1R1R3 b - - 0 28",
        moves: "b6a5 c1c8 d8c8 e4d6",
        rating: 1477,
        themes: ["advantage", "attraction", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1477)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4rk1/2p3bR/p2p4/1p1PpqN1/2P2B2/8/PP1Q4/2K1R3 b - - 0 27",
        moves: "f5f4 h7g7 g8g7 g5e6",
        rating: 1582,
        themes: ["attraction", "crushing", "master", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1582)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b2rk1/pp2ppbp/2Rp1np1/3N4/q7/1N2B1P1/PP2PPBP/3Q1RK1 b - - 0 13",
        moves: "b7c6 d5e7 g8h8 g2c6",
        rating: 1797,
        themes: ["crushing", "discoveredAttack", "master", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1797)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "2k5/p6p/1b1pPq2/1bpQ3p/2P5/5P2/P4P2/R4K2 b - - 0 32",
        moves: "b5e8 d5a8 c8c7 a8e8 f6a1 f1g2",
        rating: 1263,
        themes: ["advantage", "endgame", "long", "sacrifice", "skewer"],
        description: "Intermediate Tactics - Play as Black - Skewer (Rating: 1263)",
        hint: "Force the valuable piece to move!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r3k2r/1pp1bpp1/2nqp2p/p2pN3/3PnP2/BPN1P3/P2P2PP/R2Q1RK1 b kq - 5 12",
        moves: "d6a3 c3b5 a3b4 b5c7",
        rating: 1477,
        themes: ["advantage", "master", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1477)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "6rk/1p1P4/p2bP2p/3N2pq/P1p1b3/4Q2P/1P6/3RR2K w - - 4 40",
        moves: "e3e4 h5h3 h1g1 h3h2 g1f1 g8f8",
        rating: 1481,
        themes: ["crushing", "exposedKing", "long", "middlegame"],
        description: "Intermediate Tactics - Play as White (Rating: 1481)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "rnq1r1k1/pppb1pp1/3b3p/3p2NQ/3P4/2PBB2P/P4PP1/R4RK1 b - - 1 13",
        moves: "h6g5 h5h7 g8f8 h7h8 f8e7 e3g5",
        rating: 999,
        themes: ["middlegame"],
        description: "Beginner Tactics - Play as Black (Rating: 999)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/p7/Kp6/2p5/3b1pB1/1P3P2/P4k2/8 w - - 1 41",
        moves: "a6a7 b6b5 a7b6 c5c4 b6b5 c4c3 b5c4 c3c2",
        rating: 1689,
        themes: ["advancedPawn", "bishopEndgame", "crushing", "discoveredAttack", "discoveredCheck", "endgame", "quietMove", "veryLong"],
        description: "Advanced Tactics - Play as White (Rating: 1689)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/5p2/3rp3/1PN1nk2/8/8/1KP1R3/8 b - - 0 45",
        moves: "d6b6 e2e5 f5e5 c5d7",
        rating: 1480,
        themes: ["advantage", "attraction", "endgame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1480)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/7p/1P4p1/3R4/8/P3p1K1/3Bkr1P/8 b - - 0 50",
        moves: "e3d2 d5d2 e2d2 g3f2",
        rating: 1401,
        themes: ["crushing", "deflection", "endgame", "rookEndgame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1401)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r3k1/4bppp/4pn2/1Q2q3/n2N4/4B1NP/PP3PP1/2KR4 w - - 1 25",
        moves: "c1b1 a4c3 b2c3 c8b8",
        rating: 1706,
        themes: ["advantage", "master", "middlegame", "pin", "sacrifice", "short"],
        description: "Advanced Tactics - Play as White - Pin (Rating: 1706)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2qrb1k/pp4p1/2p2pQB/3Nn3/8/P6R/1PP3PP/3R2K1 b - - 0 21",
        moves: "g7h6 h3h6 f8h6 g6h6 h8g8 d5f6",
        rating: 1473,
        themes: ["advantage", "exposedKing", "kingsideAttack", "long", "middlegame"],
        description: "Intermediate Tactics - Play as Black (Rating: 1473)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5rk1/p3pp1p/bqB3p1/3P4/1Q6/P3N3/rb3PPP/3RR1K1 b - - 12 23",
        moves: "b2a3 b4b6 a7b6 d1a1 a2a1 e1a1",
        rating: 1758,
        themes: ["advantage", "long", "middlegame"],
        description: "Advanced Tactics - Play as Black (Rating: 1758)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "3rr1k1/1pq1npp1/p4n1p/3P1b2/8/1PN2N2/P2RBPPP/2QR2K1 b - - 2 23",
        moves: "f6d5 c3d5 c7c1 d5e7",
        rating: 1599,
        themes: ["advantage", "kingsideAttack", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1599)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "1rk4r/1pb2ppp/2n5/1Q1P1q2/3P4/6P1/3B1P1P/R3R1K1 b - - 0 29",
        moves: "c6d4 e1e8 h8e8 b5e8 c7d8 a1c1",
        rating: 1234,
        themes: ["crushing", "long", "middlegame", "queensideAttack"],
        description: "Intermediate Tactics - Play as Black (Rating: 1234)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2bQ4/ppp2pk1/3nq1pp/3N4/2P5/PP4P1/5PBP/6K1 w - - 4 29",
        moves: "d5c7 e6e1 g2f1 c8h3",
        rating: 1034,
        themes: ["advantage", "clearance", "endgame", "pin", "short"],
        description: "Beginner Tactics - Play as White - Pin (Rating: 1034)",
        hint: "Pin the opponent's piece!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "r6r/4q1k1/2p3p1/pp2N1b1/4P3/2P5/KPQ1BP2/3R3R b - - 0 24",
        moves: "h8h1 d1d7 e7d7 e5d7",
        rating: 1473,
        themes: ["advantage", "middlegame", "pin", "short"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1473)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r5/3k4/3Np3/4P3/1r1p4/1pp5/P1P2Q2/1K6 w - - 4 41",
        moves: "d6c8 b3c2 b1c1 b4b1 c1c2 b1b2",
        rating: 1736,
        themes: ["advancedPawn", "crushing", "discoveredCheck", "doubleCheck", "endgame", "long"],
        description: "Advanced Tactics - Play as White (Rating: 1736)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "1Q6/4Rppk/5n1p/1p3P2/2p5/2P1KnPP/1PB3q1/8 w - - 8 39",
        moves: "e7f7 f6d5 e3e4 f3g5",
        rating: 1628,
        themes: ["advantage", "discoveredCheck", "doubleCheck", "endgame", "master", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1628)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r6r/1bp2pk1/1p1pn1q1/p3pR2/2PPP3/2N1P3/PP3QB1/5RK1 b - - 2 26",
        moves: "e6g5 f5g5 g6g5 f2f7",
        rating: 1347,
        themes: ["master", "middlegame"],
        description: "Intermediate Tactics - Play as Black (Rating: 1347)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5r1k/p1p3b1/1p5p/3P2p1/5qP1/3Q1p1P/PPP2B2/4R1K1 b - - 2 29",
        moves: "g7e5 e1e5 f4e5 f2d4",
        rating: 1298,
        themes: ["crushing", "endgame", "pin", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1298)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "6k1/pp1b3p/2n1prpQ/2q3N1/2B5/2P5/P1P3PP/4R2K b - - 3 22",
        moves: "c5c4 h6h7 g8f8 h7h8 f8e7 h8g7",
        rating: 1640,
        themes: ["advantage", "fork", "long", "middlegame"],
        description: "Advanced Tactics - Play as Black - Fork (Rating: 1640)",
        hint: "Attack multiple pieces at once!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2q1rk1/pQ4pp/3pb3/2p1np2/P1P5/2P1P3/4BPPP/R1B2RK1 b - - 0 15",
        moves: "e6c4 e2c4 e5c4 b7d5",
        rating: 1066,
        themes: ["crushing", "middlegame", "short"],
        description: "Beginner Tactics - Play as Black (Rating: 1066)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "1q1R1rk1/pp2b1p1/2p2n1p/4p3/1P2N1b1/P5P1/1BQ2PBP/5RK1 b - - 0 25",
        moves: "f8d8 e4f6 e7f6 c2c4 g8f8 c4g4",
        rating: 1704,
        themes: ["crushing", "fork", "long", "middlegame"],
        description: "Advanced Tactics - Play as Black - Fork (Rating: 1704)",
        hint: "Attack multiple pieces at once!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "4r2k/1q1n3p/1p1p2pB/p7/3p4/P5QP/1P5K/R4R2 w - - 0 32",
        moves: "g3d6 e8e2 h2g3 b7g2 g3h4 e2e4",
        rating: 1404,
        themes: ["advantage", "long", "middlegame"],
        description: "Intermediate Tactics - Play as White (Rating: 1404)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/1p4bk/p5pp/5P2/qP6/2rp3P/3N2P1/4RQK1 b - - 0 29",
        moves: "a4b4 f5g6 h7g6 e1e6 g6h7 f1f5 h7g8 e6e8 g7f8 f5g6",
        rating: 1620,
        themes: ["attraction", "crushing", "endgame", "veryLong"],
        description: "Advanced Tactics - Play as Black (Rating: 1620)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4rk1/p1qRbpp1/b1p2n1p/4p3/Np5N/1B2B3/PPP1QPPP/3R2K1 b - - 0 17",
        moves: "c7d7 d1d7 a6e2 d7e7",
        rating: 1270,
        themes: ["advantage", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1270)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "rn2kb1r/pp3ppp/2ppB3/8/3P4/8/P1P1QPPP/q1B2RK1 b kq - 0 11",
        moves: "f7e6 e2e6 e8d8 c1g5",
        rating: 1048,
        themes: ["advantage", "middlegame", "short"],
        description: "Beginner Tactics - Play as Black (Rating: 1048)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "1n1r1r1k/p1p4p/1p1pBbp1/5P2/4p1P1/4B3/PPP5/1K1R3R b - - 0 28",
        moves: "d8e8 h1h7 h8h7 d1h1 f6h4 h1h4",
        rating: 1760,
        themes: ["attraction", "crushing", "kingsideAttack", "long", "middlegame", "sacrifice"],
        description: "Advanced Tactics - Play as Black (Rating: 1760)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1bq1rk1/ppp2pp1/5b2/3P2pQ/4P3/2NB4/PP4PP/R4RK1 b - - 1 15",
        moves: "g5g4 e4e5 g7g6 d3g6 f7g6 h5g6",
        rating: 1565,
        themes: ["advantage", "kingsideAttack", "long", "middlegame"],
        description: "Intermediate Tactics - Play as Black (Rating: 1565)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/P7/1n6/3p4/5N2/3K4/5kp1/8 b - - 1 48",
        moves: "g2g1q f4h3 f2g2 h3g1 g2g1 d3d4 g1f2 d4c5",
        rating: 1309,
        themes: ["crushing", "endgame", "fork", "veryLong"],
        description: "Intermediate Tactics - Play as Black - Fork (Rating: 1309)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "3r1rk1/p1p2ppp/2R5/8/3Q1B2/P5P1/4qP1P/5RK1 w - - 1 19",
        moves: "d4a7 d8d1 f1d1 e2d1 g1g2 d1d5",
        rating: 1222,
        themes: ["advantage", "long", "middlegame"],
        description: "Intermediate Tactics - Play as White (Rating: 1222)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5r1k/pp2b2p/2p1b3/q3N3/3PQP2/P1P1K3/1P5P/6R1 b - - 0 30",
        moves: "a5d5 e5g6 h7g6 e4g6",
        rating: 1451,
        themes: ["crushing", "master", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1451)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "1r3r1k/6p1/Q6p/p7/2pPp3/P1P1N1q1/6P1/R3R2K w - - 0 31",
        moves: "a6c4 g3h4 h1g1 h4f2",
        rating: 1371,
        themes: ["advantage", "middlegame", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1371)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2rR4/7k/2n2Qq1/p5Pp/1p5P/1P6/P1P5/1K3R2 b - - 0 36",
        moves: "c8d8 f6g6 h7g6 f1f6 g6g7 f6c6",
        rating: 1559,
        themes: ["advantage", "attraction", "endgame", "exposedKing", "fork", "long", "master", "masterVsMaster"],
        description: "Intermediate Tactics - Play as Black - Fork (Rating: 1559)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b2rk1/ppb2pp1/4p2p/2N1n3/2Pp1PPq/3P1B1P/PP5K/R1BQ1R2 w - - 0 16",
        moves: "f4e5 c7e5 h2g1 h4g3 f3g2 g3h2",
        rating: 1002,
        themes: ["advantage", "long", "middlegame"],
        description: "Beginner Tactics - Play as White (Rating: 1002)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "1r1q1rk1/1b1n1pp1/p1pPpn1p/3pN3/Q2P4/2NBP3/P4PPP/1R3RK1 w - - 0 17",
        moves: "e5c6 b7c6 a4c6 b8c8",
        rating: 1788,
        themes: ["advantage", "middlegame", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1788)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r3k1/pp1b1p2/3bpp1p/6P1/3P3P/8/PKQ2P2/4qBRR w - - 4 23",
        moves: "g5f6 g8f8 f1c4 e1b4",
        rating: 1423,
        themes: ["advantage", "defensiveMove", "master", "middlegame", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1423)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "1br3k1/p4pp1/1p3q2/2p2P2/2Pp1p2/3P3P/PP2RPB1/4R1K1 b - - 2 28",
        moves: "f6f5 e2e8 c8e8 e1e8 g8h7 g2e4",
        rating: 1218,
        themes: ["advantage", "endgame", "fork", "long", "pin"],
        description: "Intermediate Tactics - Play as Black - Fork (Rating: 1218)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2q1rk1/ppp2p1p/3b1p2/3p4/8/1P2PQ2/P1PP2PP/RN3RK1 w - - 0 12",
        moves: "f3f6 d8f6 f1f6 d6e5",
        rating: 1444,
        themes: ["advantage", "middlegame", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1444)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2q1r2/1pp3pk/p2p3p/4pb1n/P1BP1nP1/2P1B2P/2PQ1P1N/R3R1K1 w - - 1 17",
        moves: "g4f5 d8g5 h2g4 f4h3",
        rating: 1646,
        themes: ["advantage", "kingsideAttack", "middlegame", "pin", "short"],
        description: "Advanced Tactics - Play as White - Pin (Rating: 1646)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r3r1k1/1q3ppp/pp2pn2/2b1Q3/8/P1N3P1/1PPB1P1P/R3R1K1 w - - 1 18",
        moves: "a1d1 c5f2 g1f2 f6g4",
        rating: 1638,
        themes: ["advantage", "attraction", "kingsideAttack", "middlegame", "sacrifice", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1638)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b2rk1/2qnbppp/2pp1n2/4p3/p3PP2/RB1P1N2/1PPBN1PP/4QRK1 w - - 0 14",
        moves: "a3a4 a8a4 b3a4 c7a7",
        rating: 1727,
        themes: ["advantage", "master", "middlegame", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1727)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "4rrk1/1pp3p1/p1n2q1p/2Np1b2/3P1P2/P2Q2P1/1PB4P/3RR1K1 w - - 8 21",
        moves: "d3f5 e8e1 d1e1 f6d4",
        rating: 1779,
        themes: ["crushing", "kingsideAttack", "master", "middlegame", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1779)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2q1rk1/ppp1p1bR/1nn3p1/4P3/5Pb1/2NB1N2/PPP3P1/R1BQK3 b Q - 0 12",
        moves: "g8h7 f3g5 h7g8 d1g4",
        rating: 1381,
        themes: ["crushing", "discoveredAttack", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1381)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2R5/2p2p2/p7/3P4/3kP3/2p1r3/P3KN2/8 w - - 2 43",
        moves: "e2f1 c3c2 c8c7 e3c3 c7c3 d4c3",
        rating: 1161,
        themes: ["advancedPawn", "clearance", "crushing", "endgame", "long"],
        description: "Beginner Tactics - Play as White (Rating: 1161)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b2r2/2p1q2k/7p/n1N1p1p1/4Pn2/pBP1QN1P/P2R2P1/3R2K1 b - - 9 27",
        moves: "a5b3 d2d7 c8d7 d1d7 e7d7 c5d7",
        rating: 1647,
        themes: ["advantage", "long", "middlegame", "pin", "sacrifice"],
        description: "Advanced Tactics - Play as Black - Pin (Rating: 1647)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r3r1k1/pp3pp1/2p4p/2n4P/2BbN3/2PP4/PP2QPq1/R3KR2 w Q - 1 21",
        moves: "c3d4 c5e4 d3e4 e8e4",
        rating: 1646,
        themes: ["advantage", "middlegame", "pin", "short"],
        description: "Advanced Tactics - Play as White - Pin (Rating: 1646)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b1k2r/ppp2ppp/3p4/4p3/2BnPPP1/P2P4/1PPKNqP1/R1BQ2R1 b kq - 0 11",
        moves: "d4e2 g1f1 f2g2 d1e2 g2e2 d2e2",
        rating: 1776,
        themes: ["advantage", "long", "middlegame"],
        description: "Advanced Tactics - Play as Black (Rating: 1776)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/8/8/p7/2N3p1/1P3k1p/P4P2/6K1 w - - 2 49",
        moves: "c4a5 h3h2 g1h2 f3f2 a5c4 g4g3 h2h3 g3g2",
        rating: 1648,
        themes: ["advancedPawn", "crushing", "deflection", "endgame", "knightEndgame", "veryLong"],
        description: "Advanced Tactics - Play as White (Rating: 1648)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "2b3k1/1p1p2p1/2R4p/p3n3/P7/6PP/1P4P1/5RK1 b - - 0 33",
        moves: "d7c6 f1e1 e5c4 e1e8 g8f7 e8c8",
        rating: 1245,
        themes: ["advantage", "endgame", "fork", "long"],
        description: "Intermediate Tactics - Play as Black - Fork (Rating: 1245)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "3rr2k/1pp5/p1n3qp/8/5Q2/1B6/PP1B1PPN/1R4K1 b - - 0 32",
        moves: "g6b1 h2f1 b1h7 d2c3",
        rating: 1724,
        themes: ["advantage", "defensiveMove", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1724)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4rk1/pR4p1/P1p3pn/2Pp1nq1/3Pp3/4P1P1/2BNQP2/R5K1 w - - 3 26",
        moves: "c2d1 f5g3 f2g3 g5g3",
        rating: 1063,
        themes: ["crushing", "kingsideAttack", "middlegame", "short"],
        description: "Beginner Tactics - Play as White (Rating: 1063)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "rn1q1rk1/1bp1np1p/p3p1pB/1p6/4PQ2/1BP5/P3NPPP/bN2K2R b K - 1 12",
        moves: "d8d3 f4f6 d3b1 b3d1 a1c3 e2c3",
        rating: 1647,
        themes: ["crushing", "defensiveMove", "long", "middlegame", "sacrifice"],
        description: "Advanced Tactics - Play as Black (Rating: 1647)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r1k2N/1p1n1pp1/pq2p2p/8/n4P1P/b2P2N1/PP2Q1P1/K1BR3R w - - 7 22",
        moves: "d3d4 c8c1 d1c1 a3b2",
        rating: 1542,
        themes: ["crushing", "middlegame", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1542)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/8/8/3B2k1/1p6/5R2/1q4P1/q3RK2 w - - 4 62",
        moves: "e1a1 b2a1 f1e2 a1e5 e2d2 e5d5",
        rating: 1491,
        themes: ["crushing", "endgame", "fork", "long"],
        description: "Intermediate Tactics - Play as White - Fork (Rating: 1491)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "7r/5p2/R1b1pp1p/2k5/8/3B1P2/2P2K1P/8 b - - 0 33",
        moves: "h8a8 a6c6 c5c6 d3e4",
        rating: 1416,
        themes: ["advantage", "attraction", "endgame", "master", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1416)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "3r1rk1/1pp3pp/1b4b1/p7/P2N4/2P1qBP1/1P5P/R2Q1R1K w - - 0 21",
        moves: "f3b7 g6e4 b7e4 e3e4",
        rating: 1506,
        themes: ["crushing", "kingsideAttack", "middlegame", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1506)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "6k1/6r1/4p1nQ/q2pP3/2bP1P2/1pn5/1B3KP1/1B5R w - - 1 40",
        moves: "b1g6 c3e4 f2g1 a5e1 g1h2 e1g3",
        rating: 1370,
        themes: ["advantage", "long", "middlegame"],
        description: "Intermediate Tactics - Play as White (Rating: 1370)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "6rk/7p/4RPR1/1p1p4/p2P4/P1P5/bP1K2P1/8 b - - 0 55",
        moves: "g8g6 e6e8 g6g8 f6f7",
        rating: 1598,
        themes: ["advancedPawn", "crushing", "endgame", "pin", "short"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1598)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4r2/1pp4k/3p2pp/p2NpBq1/3bPp2/P2P4/1PP1Q3/2KR3R w - - 2 21",
        moves: "d5c7 f4f3 e2d2 d4e3",
        rating: 1294,
        themes: ["crushing", "discoveredAttack", "discoveredCheck", "middlegame", "pin", "short"],
        description: "Intermediate Tactics - Play as White - Pin (Rating: 1294)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r2knr/1p2n3/pq1pRp2/3P4/5Q2/6P1/PPP2PB1/R5K1 b - - 0 21",
        moves: "e7g6 e6f6 g8f6 f4f6",
        rating: 1145,
        themes: ["crushing", "master", "middlegame", "short"],
        description: "Beginner Tactics - Play as Black (Rating: 1145)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "3r1k1r/1p3pp1/p2bpn1p/2p4P/2NP4/8/PPPB1PP1/2KR3R b - - 2 21",
        moves: "c5d4 c4d6 d8d6 d2b4",
        rating: 987,
        themes: ["crushing", "master", "middlegame", "pin", "short"],
        description: "Beginner Tactics - Play as Black - Pin (Rating: 987)",
        hint: "Pin the opponent's piece!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "6rk/2p4p/2Bp3b/p3qp2/1PP5/P5PP/R6K/3Q4 w - - 2 33",
        moves: "d1f3 g8g3 f3g3 h6f4",
        rating: 1513,
        themes: ["advantage", "endgame", "pin", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as White - Pin (Rating: 1513)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "6k1/6p1/4qR1p/Q1pnp2P/4n3/4P3/PPP5/1K1N4 b - - 0 27",
        moves: "e6f6 a5a8 g8h7 a8d5",
        rating: 971,
        themes: ["advantage", "endgame", "fork", "short"],
        description: "Beginner Tactics - Play as Black - Fork (Rating: 971)",
        hint: "Attack multiple pieces at once!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "rbb2knr/pp3p2/2n4p/3N4/2BP4/5P2/PP1B1P1P/R3R1K1 b - - 3 16",
        moves: "c6d4 d2b4 f8g7 b4c3",
        rating: 1389,
        themes: ["crushing", "middlegame", "pin", "short"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1389)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r6k/7p/2qp4/4pN2/2Pp1b2/pr1P1P1P/R5Q1/R6K b - - 1 41",
        moves: "a8g8 g2g8 h8g8 f5e7",
        rating: 1557,
        themes: ["middlegame"],
        description: "Intermediate Tactics - Play as Black (Rating: 1557)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5bk1/pb3p1p/2q2Bp1/4r3/2B5/1P6/P1P2QPP/2R3K1 w - - 0 32",
        moves: "f6e5 f8c5 c4f7 g8f8 e5d6 c6d6",
        rating: 1565,
        themes: ["advantage", "long", "middlegame", "pin"],
        description: "Intermediate Tactics - Play as White - Pin (Rating: 1565)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "4r2b/5k1N/1p3qpP/p1p1rp2/P4P2/2PP2P1/1PQ4K/3R4 w - - 1 37",
        moves: "h7f6 e5e2 h2h3 e2c2 f6e8 f7e8",
        rating: 1102,
        themes: ["advantage", "endgame", "fork", "long"],
        description: "Beginner Tactics - Play as White - Fork (Rating: 1102)",
        hint: "Attack multiple pieces at once!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "rbb1r1k1/1p3pp1/p1p4p/2P5/1PB2Pn1/P1B2RP1/4N2P/3R2K1 b - - 4 23",
        moves: "g4e3 f3e3 e8e3 d1d8",
        rating: 1427,
        themes: ["crushing", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1427)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2k1r3/ppp1rqb1/3p2pn/7p/3NP3/2P2N1P/PP1Q2P1/1K2R2R b - - 2 21",
        moves: "e7e4 e1e4 e8e4 f3g5",
        rating: 1607,
        themes: ["advantage", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1607)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2q3k/1Q1b2rp/p3p2p/P1bpP3/3N1p2/2PB4/5PPP/RR5K b - - 2 27",
        moves: "d7b5 b7g7 h8g7 d4e6",
        rating: 1767,
        themes: ["advantage", "attraction", "kingsideAttack", "middlegame", "sacrifice", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1767)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4r2/p3Q3/1kp5/1b1p2pp/5q2/5P2/P5PP/1R2R1K1 b - - 1 27",
        moves: "a8e8 b1b5 c6b5 e1e6",
        rating: 1538,
        themes: ["crushing", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1538)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2q3k1/1p4b1/p1p3p1/2Np3n/1Q1P1P2/5P2/PP3KPB/4r3 w - - 0 27",
        moves: "b4e1 g7d4 f2f1 d4c5",
        rating: 922,
        themes: ["crushing", "endgame", "fork", "short"],
        description: "Beginner Tactics - Play as White - Fork (Rating: 922)",
        hint: "Attack multiple pieces at once!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r1k3/1Qp2q1p/2p1b3/2P2p2/4p2B/8/PPP3rP/2KR3R b - - 1 22",
        moves: "f7h5 b7c6 e8f7 d1d7 e6d7 c6d7",
        rating: 1516,
        themes: ["advantage", "exposedKing", "fork", "long", "master", "middlegame"],
        description: "Intermediate Tactics - Play as Black - Fork (Rating: 1516)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "3r2k1/Rp3r1p/1q4p1/3nB3/2p2P2/Q7/6PP/3R3K b - - 3 30",
        moves: "d5f4 d1d8 b6d8 a7a8",
        rating: 1318,
        themes: ["crushing", "middlegame", "pin", "short"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1318)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "4r2k/1b4p1/p2p2PR/1p2pq2/4P3/P2PQ3/1P2N1K1/8 b - - 0 36",
        moves: "g7h6 e3h6 h8g8 h6h7 g8f8 g6g7",
        rating: 1386,
        themes: ["advancedPawn", "crushing", "endgame", "exposedKing", "fork", "long"],
        description: "Intermediate Tactics - Play as Black - Fork (Rating: 1386)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b2r2/2q1bppk/p2ppn1B/1p4Qn/3NP1P1/2NB4/PPP2P1P/R4RK1 b - - 0 16",
        moves: "g7h6 e4e5 h7h8 g5h6",
        rating: 1520,
        themes: ["crushing", "deflection", "discoveredAttack", "discoveredCheck", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1520)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r1k2r/4npp1/pnQ1p2p/1p1pP3/3P3P/5NP1/3N1P2/R1R3K1 b k - 0 28",
        moves: "c8c6 c1c6 e7c6 a1a6 e8d7 a6b6",
        rating: 1063,
        themes: ["advantage", "long", "middlegame"],
        description: "Beginner Tactics - Play as Black (Rating: 1063)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "3R3r/p1b1k3/1p5p/2p1npp1/8/1PP1BbP1/P4NBP/1K2R3 b - - 0 24",
        moves: "h8d8 g2f3 e5f3 e3g5",
        rating: 1771,
        themes: ["advantage", "discoveredCheck", "doubleCheck", "master", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1771)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4bk1/pb1q1ppp/1p6/2pP1BQ1/8/2B3P1/PP3P1P/3Rr1K1 w - - 0 23",
        moves: "d1e1 d7d5 f5h7 g8h7 g5d5 b7d5",
        rating: 1498,
        themes: ["crushing", "long", "middlegame"],
        description: "Intermediate Tactics - Play as White (Rating: 1498)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "4r1k1/pp2Pppp/2nQb3/2p3B1/P6P/5N2/1q3PP1/4R1K1 b - - 0 30",
        moves: "b2b6 e1e6 f7e6 d6e6",
        rating: 1398,
        themes: ["advantage", "kingsideAttack", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1398)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5r1k/pp1b1p1p/3p2p1/3N4/1B2rP2/P6P/1bP3P1/3R1RK1 b - - 1 21",
        moves: "b2d4 d1d4 e4d4 b4c3",
        rating: 1763,
        themes: ["crushing", "master", "middlegame", "pin", "sacrifice", "short"],
        description: "Advanced Tactics - Play as Black - Pin (Rating: 1763)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "4Rrk1/1pp2rpp/3p4/p2P2n1/2P3q1/5N2/PP2Q1PP/5R1K b - - 6 23",
        moves: "f8e8 e2e8 f7f8 e8f8 g8f8 f3e5",
        rating: 1710,
        themes: ["crushing", "discoveredAttack", "discoveredCheck", "kingsideAttack", "long", "middlegame"],
        description: "Advanced Tactics - Play as Black (Rating: 1710)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "5rk1/1pr3qp/p5pQ/3p4/1PBn2N1/P6P/4RPP1/2R3K1 b - - 0 28",
        moves: "d4e2 c4e2 c7c1 h6c1",
        rating: 1686,
        themes: ["advantage", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1686)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "6k1/1p3rp1/3qR3/p5P1/2pN1P2/2P5/PPK2Q2/7r b - - 2 40",
        moves: "d6f4 e6e8 g8h7 g5g6 h7g6 f2g2",
        rating: 1584,
        themes: ["advantage", "attraction", "endgame", "long"],
        description: "Intermediate Tactics - Play as Black (Rating: 1584)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "3rr3/p1p2pkp/4B1n1/3p4/3Q4/2P2P1q/P3K1R1/6R1 b - - 1 26",
        moves: "g7g8 g2g6 h7g6 g1g6 g8f8 d4g7",
        rating: 1290,
        themes: ["crushing", "long", "middlegame", "pin"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1290)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/8/p1pK4/5k2/2p5/P1P5/8/8 w - - 2 52",
        moves: "d6c6 f5e4 c6c5 e4d3 c5b4 a6a5 b4a5 d3c3",
        rating: 1237,
        themes: ["crushing", "deflection", "endgame", "master", "pawnEndgame", "veryLong"],
        description: "Intermediate Tactics - Play as White (Rating: 1237)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r5/p3k2p/1p2b3/2p5/4R3/P3KB2/2P3PP/8 b - - 1 30",
        moves: "e7f6 e4e6 f6e6 f3g4",
        rating: 1595,
        themes: ["attraction", "crushing", "endgame", "master", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1595)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2kr3r/1pp3p1/1Pp1b3/4q2p/4N3/3P1B1P/1PP1Q1P1/R4K2 b - - 0 19",
        moves: "e5b2 a1a8 c8d7 e4c5",
        rating: 1311,
        themes: ["crushing", "master", "middlegame", "queensideAttack", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1311)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "7k/3q1p1p/R1p1b2r/1p2p2r/4P3/1P1PQ2P/1PP3P1/6RK b - - 0 29",
        moves: "h5h3 g2h3 h6h3 e3h3 e6h3 a6a8",
        rating: 1480,
        themes: ["advantage", "long", "middlegame"],
        description: "Intermediate Tactics - Play as Black (Rating: 1480)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2b1r1kb/4n3/pR4p1/3pp1Qp/P1p5/2P2R1P/3N1PPK/2q5 b - - 2 35",
        moves: "e5e4 b6g6 e7g6 g5g6",
        rating: 1138,
        themes: ["crushing", "kingsideAttack", "master", "middlegame", "short"],
        description: "Beginner Tactics - Play as Black (Rating: 1138)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "5rk1/q3bpp1/4bn1p/3p4/7B/3Q4/2B2PPP/rNR1R1K1 b - - 5 23",
        moves: "g7g6 e1e6 f7e6 d3g6",
        rating: 1401,
        themes: ["advantage", "deflection", "kingsideAttack", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1401)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "6k1/1br2p1p/p3nBp1/8/3p4/Pq1B1P2/1P1Q2PP/3R2K1 b - - 5 30",
        moves: "h7h5 d2h6 b3d1 d3f1",
        rating: 1433,
        themes: ["crushing", "master", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1433)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r1brk1/5p2/1q2pQpp/3pP3/1p1P3N/2P5/1b4PP/1B3RK1 b - - 1 31",
        moves: "b2c3 h4g6 b6d4 g1h1",
        rating: 1468,
        themes: ["crushing", "defensiveMove", "master", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1468)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1bq1rk1/p1p1b1pp/1p1p1pn1/3P3Q/4N3/3B3N/PPP2PPP/2KR3R b - - 7 12",
        moves: "g6e5 e4f6 f8f6 h5h7 g8f7 h3g5",
        rating: 1385,
        themes: ["crushing", "kingsideAttack", "long", "middlegame"],
        description: "Intermediate Tactics - Play as Black (Rating: 1385)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2kr3r/ppqn1pp1/2p1pnp1/6B1/2NP4/2N3b1/PPP2PQ1/R3K2R w KQ - 0 15",
        moves: "f2g3 h8h1 g2h1 c7g3",
        rating: 1171,
        themes: ["advantage", "middlegame", "short"],
        description: "Beginner Tactics - Play as White (Rating: 1171)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "r5r1/8/p1pqP3/3p1Rpk/1p2n3/5QP1/PPP4K/5R2 b - - 1 31",
        moves: "h5g6 f5f6 e4f6 f3f6",
        rating: 942,
        themes: ["crushing", "middlegame", "sacrifice", "short"],
        description: "Beginner Tactics - Play as Black (Rating: 942)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "1k1r3r/ppq2ppp/3bpn2/P7/1Pp3P1/2P1PP2/1B1NQ2P/R3K2R w KQ - 3 20",
        moves: "e2c4 d6g3 h2g3 c7g3",
        rating: 1745,
        themes: ["advantage", "middlegame", "sacrifice", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1745)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4rk1/1ppq1pbp/p2p2p1/3Nn3/1PP5/4P1P1/PB3PK1/R2Q1R2 b - - 0 16",
        moves: "e5c4 b2g7 g8g7 d1d4",
        rating: 1308,
        themes: ["advantage", "attraction", "kingsideAttack", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1308)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "4r2k/1b3Bbp/p5p1/1P4P1/1P1rp1q1/2N1B3/3Q3P/2R2R1K w - - 1 28",
        moves: "f7e8 d4d2 e3d2 e4e3",
        rating: 1226,
        themes: ["crushing", "discoveredAttack", "discoveredCheck", "master", "middlegame", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1226)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r3k2r/pp1Rb1pp/2p1p3/8/6P1/4Bp1P/PPP2P2/3R2K1 b kq - 3 18",
        moves: "a8d8 d7e7 e8e7 e3g5",
        rating: 1593,
        themes: ["advantage", "attraction", "endgame", "master", "masterVsMaster", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1593)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2rq1rk1/6pp/4pn2/p1bp4/Q7/1P2P1P1/5PBP/R1B1R1K1 w - - 0 20",
        moves: "a4a5 d8a5 a1a5 c5b4",
        rating: 1534,
        themes: ["advantage", "middlegame", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1534)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2rq1rk1/pp2p2p/2n3p1/3p1p2/1P1P4/P1B1bPP1/3NQ1KP/2R2R2 b - - 1 18",
        moves: "e3d4 e2e6 g8g7 c3d4 c6d4 e6e5",
        rating: 1639,
        themes: ["advantage", "intermezzo", "kingsideAttack", "long", "middlegame"],
        description: "Advanced Tactics - Play as Black (Rating: 1639)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "5rk1/3q2p1/2rP1p1p/p1p1p3/PnR1Q3/1P4B1/5PPP/1B3K2 b - - 1 28",
        moves: "c6d6 e4h7 g8f7 b1g6 f7e6 g6f5",
        rating: 1320,
        themes: ["advantage", "kingsideAttack", "long", "middlegame"],
        description: "Intermediate Tactics - Play as Black (Rating: 1320)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "1r1k2r1/2b2p2/1p2pP2/4q3/QPP4p/P2R3P/6P1/5R1K b - - 0 32",
        moves: "c7d6 d3d6 e5d6 f1d1",
        rating: 1734,
        themes: ["advantage", "middlegame", "pin", "sacrifice", "short"],
        description: "Advanced Tactics - Play as Black - Pin (Rating: 1734)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/8/3p2Kp/2bB4/1p2Pp2/p3kP1P/P1P5/8 b - - 9 48",
        moves: "e3f3 e4e5 f3e3 e5e6",
        rating: 1285,
        themes: ["bishopEndgame", "crushing", "discoveredAttack", "discoveredCheck", "endgame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1285)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2rq1rk1/pb1n1ppp/1p3B2/2p5/4P3/1P4P1/P2N1PBP/R2Q1RK1 b - - 0 15",
        moves: "d8f6 e4e5 d7e5 g2b7",
        rating: 1403,
        themes: ["crushing", "discoveredAttack", "master", "masterVsMaster", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1403)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4r2/pp3pk1/2bqp1p1/4R2Q/8/3B4/PPP5/1K4R1 b - - 0 36",
        moves: "f8h8 g1g6 f7g6 h5g6",
        rating: 1227,
        themes: ["advantage", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1227)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2k4r/1pprnppp/p1p1q3/8/P1N1P3/1Q2P2P/1R4P1/5RK1 b - - 2 18",
        moves: "b7b6 c4b6 c7b6 b3b6",
        rating: 1036,
        themes: ["advantage", "middlegame", "queensideAttack", "short"],
        description: "Beginner Tactics - Play as Black (Rating: 1036)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "5r1r/p1p3k1/2Q5/3NP3/3P1p2/4n1qp/PPP5/1RR4K w - - 0 28",
        moves: "c1g1 g3g2 g1g2 h3g2 h1g1 h8h1",
        rating: 1630,
        themes: ["advancedPawn", "crushing", "discoveredCheck", "doubleCheck", "exposedKing", "long", "middlegame", "sacrifice"],
        description: "Advanced Tactics - Play as White (Rating: 1630)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "3rr1k1/1ppq1p1p/p4Qp1/4p3/3n4/P2P3P/BPP2P1K/4R1R1 b - - 0 25",
        moves: "d4c2 g1g6 h7g6 f6g6 g8f8 g6h6 f8e7 e1e5",
        rating: 1781,
        themes: ["crushing", "interference", "kingsideAttack", "middlegame", "pin", "sacrifice", "veryLong"],
        description: "Advanced Tactics - Play as Black - Pin (Rating: 1781)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "3rr2k/Qb3p2/1p2p2p/8/3q1PR1/7P/PPB3RK/8 b - - 1 30",
        moves: "b7g2 a7f7 g2e4 c2e4 d4f2 g4g2",
        rating: 1604,
        themes: ["crushing", "long", "middlegame"],
        description: "Advanced Tactics - Play as Black (Rating: 1604)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "3q2k1/p4p1p/3r4/5p2/4r3/1P1Q3P/P4PP1/3R2K1 w - - 0 31",
        moves: "d3d6 e4e1 d1e1 d8d6",
        rating: 997,
        themes: ["advantage", "deflection", "endgame", "short"],
        description: "Beginner Tactics - Play as White (Rating: 997)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2qr3/2p3kN/p4np1/1p2p3/4b3/1P1P4/1PPQ1PP1/R3K2R b KQ - 0 21",
        moves: "e4g2 d2h6 g7f7 h7g5 f7e7 h6g7 e7d6 g5f7",
        rating: 1715,
        themes: ["advantage", "middlegame", "veryLong"],
        description: "Advanced Tactics - Play as Black (Rating: 1715)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b1k2N/p1p3pp/2p5/4p3/5n1q/3P1Q2/PPP4P/RNB2K2 w q - 0 15",
        moves: "c1f4 c8h3 f1e2 h3g4",
        rating: 1555,
        themes: ["crushing", "middlegame", "pin", "short"],
        description: "Intermediate Tactics - Play as White - Pin (Rating: 1555)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5r2/p3k3/1pb1P3/3p2NQ/3P2P1/4n1B1/3q1PK1/7R w - - 10 38",
        moves: "g2g1 d2e1 g1h2 f8f2 g3f2 e1f2 h2h3 f2g2",
        rating: 1763,
        themes: ["crushing", "deflection", "middlegame", "veryLong"],
        description: "Advanced Tactics - Play as White (Rating: 1763)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "1r4k1/QP3pp1/2pq4/3p3p/8/4P3/R5K1/8 b - - 4 36",
        moves: "h5h4 a7b8 d6b8 a2a8",
        rating: 1574,
        themes: ["clearance", "crushing", "endgame", "pin", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1574)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r6k/p2b4/2nP1r2/2p1pnBP/2P3R1/Pp6/1P1RN3/1K3B2 b - - 1 28",
        moves: "f6d6 d2d6 f5d6 g5f6 h8h7 g4g7",
        rating: 1322,
        themes: ["advantage", "exposedKing", "kingsideAttack", "long", "middlegame"],
        description: "Intermediate Tactics - Play as Black (Rating: 1322)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "1r5r/3knQ1p/4p3/p2pP2P/Nq3P2/1P6/P5P1/1KR4R b - - 1 23",
        moves: "b4a4 c1c7 d7c7 f7e7",
        rating: 1176,
        themes: ["attraction", "crushing", "deflection", "middlegame", "sacrifice", "short"],
        description: "Beginner Tactics - Play as Black (Rating: 1176)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "2k4r/pp3ppp/2p2n2/2b1B3/3Rn3/1P3B2/P1P1NPPP/6K1 w - - 4 18",
        moves: "d4e4 f6e4 f3e4 h8e8 e4f5 c8d8",
        rating: 1258,
        themes: ["advantage", "long", "middlegame"],
        description: "Intermediate Tactics - Play as White (Rating: 1258)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r3r1k1/pp3pp1/2p2n1p/3p4/3Pbq2/P3RNPP/1PP1QP2/4RBK1 b - - 0 20",
        moves: "e4f3 e3e8 f6e8 e2e8 a8e8 e1e8",
        rating: 899,
        themes: ["crushing", "kingsideAttack", "long", "master", "middlegame"],
        description: "Beginner Tactics - Play as Black (Rating: 899)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2r2k1/2q2p2/pn3pb1/2p1p2p/2P4P/1PN3Q1/PBB3P1/3R3K w - - 0 26",
        moves: "d1d8 a8d8 c2g6 f7g6 g3g6 c7g7",
        rating: 1533,
        themes: ["advantage", "long", "middlegame"],
        description: "Intermediate Tactics - Play as White (Rating: 1533)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "3r1rk1/4ppb1/2p3pR/p1N1P3/Pq1P1Q2/1p4P1/1P3PK1/7R b - - 0 30",
        moves: "d8d4 h6h8 g7h8 f4h6 d4h4 h1h4",
        rating: 1563,
        themes: ["clearance", "crushing", "long", "middlegame", "sacrifice"],
        description: "Intermediate Tactics - Play as Black (Rating: 1563)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1bqr1k1/pp3R1p/1np1p1p1/6b1/3P4/2PB3Q/PP2N1PP/R5K1 b - - 0 15",
        moves: "g8f7 h3h7 f7f8 a1f1",
        rating: 1701,
        themes: ["advantage", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1701)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "4rr1k/ppp2q1p/3pb1p1/n1n5/2P5/2P1P1B1/P2NBPPP/2RQ1RK1 b - - 1 22",
        moves: "a5c4 d2c4 e6c4 d1d4",
        rating: 1644,
        themes: ["crushing", "master", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1644)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r1k3/pp2qp1Q/4p1pB/8/3b4/2r4R/P4PPP/3R2K1 b - - 4 26",
        moves: "c3h3 h7g8 e8d7 d1d4",
        rating: 1599,
        themes: ["crushing", "master", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1599)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r3r1k1/pb3ppp/5n2/2b5/2P1n3/1PN2N2/PB2BPPP/R2q1RK1 w - - 0 14",
        moves: "a1d1 e4c3 b2c3 e8e2",
        rating: 1711,
        themes: ["advantage", "capturingDefender", "discoveredAttack", "middlegame", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1711)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "1rr3k1/2q2pp1/Rn3b1p/1P3P2/3nP3/1Q1pBN1P/1P3PP1/2R3K1 w - - 1 28",
        moves: "f3d4 c7c1 e3c1 c8c1",
        rating: 863,
        themes: ["advantage", "master", "middlegame", "short"],
        description: "Beginner Tactics - Play as White (Rating: 863)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "1rb1kb1r/B1Qp1ppp/p1n1q3/1p1Np3/4P3/P2B4/1PP2PPP/R3K2R b KQk - 3 14",
        moves: "f8d6 a7b8 d6c7 d5c7",
        rating: 1542,
        themes: ["advantage", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1542)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "1k5r/p1q2pp1/Ppp3p1/3P4/3P4/1Q4r1/1P1B2B1/R1R3K1 w - - 0 25",
        moves: "b3c4 g3g2 g1g2 c7h2",
        rating: 1246,
        themes: ["advantage", "attraction", "kingsideAttack", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1246)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5rk1/4q3/p1r4p/Pp1pN1pQ/1P1Pn3/4P2P/6P1/2R3K1 w - - 0 31",
        moves: "c1c6 f8f1 g1h2 f1h1 h2h1 e4g3 h1h2 g3h5",
        rating: 1593,
        themes: ["advantage", "attraction", "endgame", "fork", "sacrifice", "veryLong"],
        description: "Intermediate Tactics - Play as White - Fork (Rating: 1593)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r3k2r/1pp2pp1/p7/6qp/3N2n1/2P1PbK1/PP3PP1/R1BQ1R2 w kq - 0 15",
        moves: "d4f3 h5h4 g3h3 g4f2 h3h2 g5g3",
        rating: 1728,
        themes: ["crushing", "deflection", "exposedKing", "long", "middlegame"],
        description: "Advanced Tactics - Play as White (Rating: 1728)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b1k2r/ppp1q1pp/2np1n2/1B2p1B1/8/2Q2N2/P4PPP/R3R1K1 b kq - 1 14",
        moves: "c8d7 b5c6 b7c6 f3e5 d6e5 e1e5",
        rating: 1779,
        themes: ["advantage", "long", "middlegame", "pin"],
        description: "Advanced Tactics - Play as Black - Pin (Rating: 1779)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b2rk1/1p2qp1p/2p5/2P2R1Q/1p6/3Bp3/P5PP/3R2K1 b - - 0 22",
        moves: "c8f5 d3f5 f7f6 d1d7",
        rating: 1554,
        themes: ["advantage", "master", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1554)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4rk1/p3bpp1/2p1pn1p/q1Pp4/3PPB2/2N1P2P/P1Q2KP1/R4R2 w - - 3 17",
        moves: "e4e5 a5c3 c2c3 f6e4",
        rating: 1482,
        themes: ["advantage", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1482)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1bq1Nk1/ppp2p2/3p2p1/8/2P1p3/P1b1P1P1/4KPP1/R2Q1B1R b - - 1 15",
        moves: "c3a1 d1a1 g8f8 h1h8",
        rating: 1666,
        themes: ["crushing", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1666)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/8/p5p1/1p3kP1/1P5r/P3R1KP/8/8 b - - 2 46",
        moves: "f5g5 e3e5 g5f6 g3h4 f6e5 h4g5",
        rating: 976,
        themes: ["crushing", "deflection", "endgame", "long", "rookEndgame"],
        description: "Beginner Tactics - Play as Black (Rating: 976)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r5/7p/5p2/3n4/R4P2/7P/P1pk2P1/4RK2 b - - 3 43",
        moves: "c2c1q a4d4 d2c2 e1c1 c2c1 d4d5",
        rating: 1453,
        themes: ["advantage", "endgame", "fork", "long"],
        description: "Intermediate Tactics - Play as Black - Fork (Rating: 1453)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "3r3r/1kp2p2/1p6/1Q1Pp2p/4P1bR/NR3pP1/1KP2P2/4q3 b - - 0 32",
        moves: "e1e4 b5c6 b7b8 a3b5",
        rating: 1649,
        themes: ["crushing", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1649)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r3r1k1/p1qb1ppp/1pnb4/8/2B2PP1/3P1N1P/PPPB1Q2/R4RK1 w - - 0 17",
        moves: "f3g5 d6c5 c4f7 g8h8",
        rating: 1572,
        themes: ["advantage", "middlegame", "pin", "short"],
        description: "Intermediate Tactics - Play as White - Pin (Rating: 1572)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "bR3rk1/3n1ppp/p3p3/q2p4/2pQ4/6PN/2P1PPBP/1R4K1 b - - 0 28",
        moves: "f8b8 b1b8 d7b8 d4a7 a5b5 a7a8",
        rating: 1074,
        themes: ["advantage", "fork", "long", "master", "middlegame"],
        description: "Beginner Tactics - Play as Black - Fork (Rating: 1074)",
        hint: "Attack multiple pieces at once!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "rn1qr2k/4Nppp/p2p1n2/3B4/1p3P2/8/PPP1Q1PP/R1B1R1K1 b - - 0 16",
        moves: "f6d5 e7g6 h7g6 e2e8 d8e8 e1e8",
        rating: 1186,
        themes: ["advantage", "discoveredAttack", "kingsideAttack", "long", "middlegame"],
        description: "Beginner Tactics - Play as Black (Rating: 1186)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "3R4/5rk1/1Q4pp/4n3/1P4n1/6P1/P1q2PP1/3R2K1 w - - 1 29",
        moves: "f2f3 e5f3 g2f3 c2h2",
        rating: 1797,
        themes: ["crushing", "master", "middlegame", "sacrifice", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1797)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b4r/pp1kn1pp/3Np3/3pn3/2P4P/P4N2/1q2B1P1/1R1Q1K1R b - - 1 18",
        moves: "b2a3 f3e5 d7d6 e5f7",
        rating: 1501,
        themes: ["advantage", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1501)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "1r2rk2/5PbQ/3ppq2/p2B4/1p6/8/PPP5/1K4R1 w - - 1 29",
        moves: "f7e8q b8e8 h7g7 f6g7 g1g7 f8g7",
        rating: 1185,
        themes: ["advantage", "hangingPiece", "long", "middlegame"],
        description: "Beginner Tactics - Play as White (Rating: 1185)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "1r2k1r1/b1pq3p/p2p1pb1/4P3/8/1P3N1P/PN2RPP1/R2Q1K2 b - - 0 21",
        moves: "f6e5 f3e5 d6e5 e2e5 e8d8 e5d5",
        rating: 1631,
        themes: ["crushing", "exposedKing", "long", "middlegame", "pin"],
        description: "Advanced Tactics - Play as Black - Pin (Rating: 1631)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "1r5r/pp2kpR1/3p1bQ1/q1pPpP2/8/2PP4/1P4PP/5RK1 b - - 4 24",
        moves: "f6g7 f5f6 g7f6 g6f6 e7d7 f6f7",
        rating: 1252,
        themes: ["advantage", "deflection", "endgame", "fork", "long"],
        description: "Intermediate Tactics - Play as Black - Fork (Rating: 1252)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b1q1k1/ppp3pp/5r2/4NpN1/6nP/2PRP3/PPQ2PP1/2K4R b - - 0 17",
        moves: "e8e5 d3d8 f6f8 c2b3",
        rating: 1594,
        themes: ["crushing", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1594)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "1R3rk1/p3bp2/2p1p2p/3nP1pB/2pP4/5QB1/q1P2P1P/6K1 b - - 0 23",
        moves: "f8b8 f3f7 g8h8 h5g6 a2a1 g1g2 d5e3 f2e3",
        rating: 1570,
        themes: ["crushing", "middlegame", "quietMove", "veryLong"],
        description: "Intermediate Tactics - Play as Black (Rating: 1570)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2q2k1/p4ppp/2p5/2bnr3/3N2b1/P2QPR2/1P4PP/RBB3K1 b - - 3 18",
        moves: "g4f3 d3h7 g8f8 h7h8 f8e7 d4c6",
        rating: 1645,
        themes: ["advantage", "kingsideAttack", "long", "middlegame"],
        description: "Advanced Tactics - Play as Black (Rating: 1645)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "5r1k/1p3qp1/2p1p2p/2Bp1r2/5b2/1QP3P1/PP5P/3R1RK1 w - - 0 29",
        moves: "c5f8 f4e3 g1g2 f5f2 f1f2 f7f2",
        rating: 1644,
        themes: ["advantage", "kingsideAttack", "long", "middlegame"],
        description: "Advanced Tactics - Play as White (Rating: 1644)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2q2k1/4br1p/p1b1p1B1/1pppP2Q/5P2/2P1B3/PP4PP/R4RK1 b - - 0 20",
        moves: "h7g6 h5g6 f7g7 g6e6",
        rating: 1167,
        themes: ["advantage", "kingsideAttack", "middlegame", "short"],
        description: "Beginner Tactics - Play as Black (Rating: 1167)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "r3k2r/pppqb1pp/2p1bB2/6N1/3P4/8/PPP3PP/RN1Q1RK1 b kq - 0 12",
        moves: "e7f6 g5e6 d7e6 f1e1 f6d4 g1h1",
        rating: 1702,
        themes: ["advantage", "defensiveMove", "long", "middlegame", "pin"],
        description: "Advanced Tactics - Play as Black - Pin (Rating: 1702)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4bk1/1pQ3p1/6b1/3p1qN1/3B4/p1P2R1P/5PPK/8 b - - 1 35",
        moves: "f5g5 f3f8 g8f8 c7g7",
        rating: 1446,
        themes: ["advantage", "attraction", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1446)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r1b2r1k/pp4bp/6p1/3Q4/8/4PN2/Pq1B1KP1/1R5R b - - 3 20",
        moves: "b2e5 h1h7 h8h7 b1h1",
        rating: 1589,
        themes: ["attraction", "crushing", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1589)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "r2q1rk1/pb3ppR/1p2p1n1/2pnP3/4N3/2P2NP1/PPB2PP1/R2QK3 b Q - 0 15",
        moves: "g8h7 f3g5 h7g8 d1h5",
        rating: 1543,
        themes: ["clearance", "crushing", "middlegame", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1543)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r3k1/4Q1pp/r1q1Pp2/p1p5/Pp3RN1/1P1P2P1/2P3PK/8 b - - 0 32",
        moves: "c6e8 g4f6 g7f6 f4g4",
        rating: 1661,
        themes: ["clearance", "crushing", "endgame", "kingsideAttack", "master", "masterVsMaster", "sacrifice", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1661)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/3k4/B4Bp1/3nKpP1/p1p5/1b6/1P6/8 w - - 0 48",
        moves: "e5d5 c4c3 d5c5 c3c2",
        rating: 1550,
        themes: ["advancedPawn", "bishopEndgame", "crushing", "discoveredAttack", "discoveredCheck", "endgame", "master", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1550)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2Q1r1k1/5pp1/pb1p1q2/1p1P3p/1P2n3/4N2P/3N1PP1/2R1R1K1 b - - 0 25",
        moves: "e8c8 c1c8 g8h7 d2e4",
        rating: 1025,
        themes: ["crushing", "middlegame", "short"],
        description: "Beginner Tactics - Play as Black (Rating: 1025)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "r5rk/ppp1Npp1/2b4p/4R2P/8/6Q1/qPP2PP1/2KR4 w - - 0 25",
        moves: "e7g8 a2a1 c1d2 a8d8",
        rating: 1230,
        themes: ["crushing", "master", "middlegame", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1230)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/p4pp1/3P2k1/2n1q3/1p6/8/1P3NQ1/5K2 b - - 5 35",
        moves: "e5g5 g2g5 g6g5 f2e4 c5e4 d6d7",
        rating: 1443,
        themes: ["advancedPawn", "advantage", "attraction", "endgame", "exposedKing", "long", "sacrifice"],
        description: "Intermediate Tactics - Play as Black (Rating: 1443)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r5/p4rpk/1p1P1p1p/8/6R1/3Q3P/qB3PP1/6K1 b - - 1 32",
        moves: "f6f5 g4g7 f7g7 d3f5",
        rating: 1346,
        themes: ["crushing", "deflection", "endgame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as Black (Rating: 1346)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "4r3/R7/6kp/1P6/4pP2/3pK1P1/P1rB3P/8 w - - 1 33",
        moves: "b5b6 c2d2 e3d2 e4e3 d2d3 e3e2",
        rating: 1168,
        themes: ["advancedPawn", "attraction", "crushing", "endgame", "long", "sacrifice"],
        description: "Beginner Tactics - Play as White (Rating: 1168)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'tactics' as const
    },
    {
        fen: "8/p3k1p1/4p2p/2P1K3/2PR2P1/P6r/8/8 w - - 1 34",
        moves: "c5c6 h3e3 e5f4 e6e5 f4e3 e5d4 e3d4 e7d6",
        rating: 1452,
        themes: ["advantage", "endgame", "fork", "rookEndgame", "veryLong"],
        description: "Intermediate Tactics - Play as White - Fork (Rating: 1452)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2r1r1k1/pp3pp1/7p/3PQ3/2n1N3/8/P4PPP/R3R1K1 b - - 0 25",
        moves: "c4e5 e4d6 e5f3 g2f3 e8e1 a1e1",
        rating: 1344,
        themes: ["advantage", "endgame", "fork", "long"],
        description: "Intermediate Tactics - Play as Black - Fork (Rating: 1344)",
        hint: "Attack multiple pieces at once!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "2k2b1r/1pp2ppp/p1P1p3/8/2P2r2/5N2/PP3P1P/2KR3R b - - 0 17",
        moves: "f4f3 d1d8 c8d8 c6b7",
        rating: 1786,
        themes: ["advancedPawn", "advantage", "deflection", "endgame", "queensideAttack", "sacrifice", "short"],
        description: "Advanced Tactics - Play as Black (Rating: 1786)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "3q1rk1/4ppbp/p1bp1np1/8/1r2P1PP/2N1BP2/1PPQB3/1K1R3R w - - 0 17",
        moves: "c3a2 b4b2 b1b2 f6e4",
        rating: 1737,
        themes: ["crushing", "discoveredAttack", "discoveredCheck", "middlegame", "queensideAttack", "sacrifice", "short"],
        description: "Advanced Tactics - Play as White (Rating: 1737)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r3k2r/ppq3p1/2p1pPb1/2b4p/2B3nP/P5N1/1PP1RPP1/R1BQ2K1 b kq - 0 15",
        moves: "c7g3 e2e6 e8f8 f6g7 f8g7 d1d7",
        rating: 1603,
        themes: ["advancedPawn", "advantage", "attraction", "exposedKing", "long", "middlegame"],
        description: "Advanced Tactics - Play as Black (Rating: 1603)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r4r2/1p3pk1/4p1p1/3p3R/p2P3P/P1P3Q1/1q3PP1/4R1K1 b - - 0 24",
        moves: "b2a3 g3e5 f7f6 e5c7 f8f7 h5h7 g7h7 c7f7",
        rating: 1712,
        themes: ["attraction", "crushing", "deflection", "endgame", "veryLong"],
        description: "Advanced Tactics - Play as Black (Rating: 1712)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r7/1ppqr2k/6pp/1bPPp3/pP6/P1Q3PP/3K2B1/4R2R w - - 0 28",
        moves: "e1e5 e7e5 c3e5 a8e8 e5f6 e8e2",
        rating: 1689,
        themes: ["advantage", "long", "middlegame"],
        description: "Advanced Tactics - Play as White (Rating: 1689)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "1r2k2r/pp2nppp/2n5/2Q1P1q1/2Pp4/5B2/PP3PPP/RN3RK1 b k - 0 15",
        moves: "g5e5 f3c6 e7c6 c5e5 c6e5 f1e1 f7f6 f2f4",
        rating: 1553,
        themes: ["advantage", "intermezzo", "middlegame", "pin", "veryLong"],
        description: "Intermediate Tactics - Play as Black - Pin (Rating: 1553)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "5rk1/p1pqn3/2ppp1pP/4b3/4P2P/2N1Br2/PPPQ4/2KR3R w - - 1 17",
        moves: "d1g1 f3e3 d2e3 e5f4",
        rating: 1669,
        themes: ["crushing", "middlegame", "pin", "sacrifice", "short"],
        description: "Advanced Tactics - Play as White - Pin (Rating: 1669)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "2kr2r1/pp2bp1p/4p3/8/2Ppn3/1P1q1N2/P2P1PPP/RN1Q1RK1 w - - 0 18",
        moves: "f3e5 g8g2 g1g2 d8g8",
        rating: 1582,
        themes: ["attraction", "crushing", "kingsideAttack", "middlegame", "sacrifice", "short"],
        description: "Intermediate Tactics - Play as White (Rating: 1582)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'tactics' as const
    },
    {
        fen: "3r3r/1Q5p/2NPk3/2p1p1n1/2q5/2P5/P5PP/5RK1 b - - 3 24",
        moves: "d8d6 b7e7 e6d5 f1d1",
        rating: 1789,
        themes: ["crushing", "fork", "middlegame", "short"],
        description: "Advanced Tactics - Play as Black - Fork (Rating: 1789)",
        hint: "Attack multiple pieces at once!",
        complexity: 'advanced' as const,
        category: 'tactics' as const
    },
    {
        fen: "r7/p2k1pp1/p1p1pn2/3p4/3P4/P3PQp1/1PP2P1q/2K4R w - - 0 20",
        moves: "h1h2 g3h2 f3h3 f6g4",
        rating: 1290,
        themes: ["advancedPawn", "advantage", "endgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1290)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "4r3/p5k1/2p2R1p/2Pp4/1P1pr1P1/P6P/8/3R3K w - - 1 35",
        moves: "f6c6 e4e1 d1e1 e8e1 h1g2 d4d3",
        rating: 1156,
        themes: ["crushing", "endgame", "exposedKing", "long", "rookEndgame"],
        description: "Beginner Strategy - Play as White (Rating: 1156)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p1p4p/4Pk2/2PP1p1P/1r3r2/5B2/P3RK2/8 b - - 3 38",
        moves: "f6e7 d5d6 c7d6 c5d6 e7d6 e6e7",
        rating: 1177,
        themes: ["advancedPawn", "advantage", "endgame", "exposedKing", "long", "master"],
        description: "Beginner Strategy - Play as Black (Rating: 1177)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "7R/8/8/6p1/2p1p1k1/2PbK2p/P7/8 w - - 4 71",
        moves: "e3f2 e4e3 f2e3 g4g3",
        rating: 1623,
        themes: ["crushing", "defensiveMove", "endgame", "master", "short"],
        description: "Advanced Strategy - Play as White (Rating: 1623)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "3r4/5k2/p4Pp1/2pK2Pp/2R5/P7/8/8 w - - 7 51",
        moves: "d5c5 d8c8 c5d4 c8c4 d4c4 h5h4",
        rating: 1438,
        themes: ["crushing", "defensiveMove", "endgame", "long", "rookEndgame"],
        description: "Intermediate Strategy - Play as White (Rating: 1438)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p7/5P2/PP1bp3/4N3/K2p4/2k5/8 b - - 0 48",
        moves: "d3d2 e4d2 c2d2 b5b6 a7b6 a5b6",
        rating: 1794,
        themes: ["crushing", "endgame", "long", "sacrifice"],
        description: "Advanced Strategy - Play as Black (Rating: 1794)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "2kr4/pp3Rp1/2p1p1P1/4P3/4p3/2P5/PP6/1K6 w - - 0 28",
        moves: "f7g7 e4e3 g7h7 e3e2 h7h1 d8d1",
        rating: 1444,
        themes: ["advancedPawn", "crushing", "endgame", "long", "rookEndgame"],
        description: "Intermediate Strategy - Play as White (Rating: 1444)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "6r1/1pp5/p2kp2R/3b1p2/3P1N2/P1P3rP/1P4PK/6R1 w - - 2 34",
        moves: "g1e1 g3g2 f4g2 g8g2",
        rating: 918,
        themes: ["crushing", "endgame", "short"],
        description: "Beginner Strategy - Play as White (Rating: 918)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/7p/3p1p2/2pP4/P3k3/1P1p4/6P1/4K3 b - - 3 37",
        moves: "c5c4 b3c4 e4d4 a4a5 d4c4 a5a6 c4d5 a6a7",
        rating: 1343,
        themes: ["advancedPawn", "crushing", "endgame", "pawnEndgame", "quietMove", "veryLong"],
        description: "Intermediate Strategy - Play as Black (Rating: 1343)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "2k5/p7/8/4P2p/5Q2/1PPqP1PK/7P/8 w - - 3 44",
        moves: "f4c4 d3c4 b3c4 a7a5 h3h4 a5a4 h4h5 a4a3",
        rating: 1168,
        themes: ["advantage", "endgame", "queenEndgame", "quietMove", "veryLong"],
        description: "Beginner Strategy - Play as White (Rating: 1168)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1k6/1P2p1p1/2KpP3/7P/8/8/8 w - - 1 48",
        moves: "c5d6 d5d4 d6e6 d4d3",
        rating: 1222,
        themes: ["crushing", "endgame", "pawnEndgame", "quietMove", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1222)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "5k2/R5pp/4pp2/8/2p5/1p2N1P1/1P3PKP/2r5 w - - 0 31",
        moves: "a7d7 c4c3 b2c3 b3b2",
        rating: 1267,
        themes: ["advancedPawn", "crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1267)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "2k5/1p3R1p/p2p4/6p1/3N2P1/1PP3KP/1P3P2/4q3 w - - 2 39",
        moves: "f7h7 e1e5 g3f3 e5f4 f3g2 f4e4",
        rating: 1684,
        themes: ["crushing", "endgame", "long"],
        description: "Advanced Strategy - Play as White (Rating: 1684)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "5k2/p4p2/1p3p2/1B2nP1Q/1P6/P3q3/6KP/8 b - - 1 37",
        moves: "e3a3 h5h8 f8e7 h8e8 e7d6 e8d8",
        rating: 1621,
        themes: ["advantage", "endgame", "long", "master"],
        description: "Advanced Strategy - Play as Black (Rating: 1621)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "3Bk1K1/4P3/8/8/ppp3P1/P7/1P6/8 w - - 0 56",
        moves: "d8a5 c4c3 b2c3 b4b3 a5b4 b3b2",
        rating: 1710,
        themes: ["advancedPawn", "bishopEndgame", "crushing", "endgame", "long"],
        description: "Advanced Strategy - Play as White (Rating: 1710)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/4k3/K4p2/4P2p/6pP/P5P1/8 b - - 0 43",
        moves: "f5e4 a5b4 e6d5 b4c3",
        rating: 1288,
        themes: ["crushing", "defensiveMove", "endgame", "pawnEndgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1288)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/R4pp1/pr6/7k/5K1P/5P2/8/8 w - - 0 44",
        moves: "a7f7 b6f6 f7f6 g7f6 f4f5 a6a5",
        rating: 1604,
        themes: ["crushing", "defensiveMove", "endgame", "long", "rookEndgame"],
        description: "Advanced Strategy - Play as White (Rating: 1604)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1p3rpk/p2p1qp1/3Q2b1/2P5/1P2p3/P3R1PP/4R1K1 w - - 8 33",
        moves: "d5e4 f6f2 e2f2 e3f2",
        rating: 1342,
        themes: ["advancedPawn", "crushing", "endgame", "sacrifice", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1342)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/4k3/1p3P2/3pP1p1/bP1P2pp/3B4/5KP1/8 b - - 0 34",
        moves: "e7e6 d3f5 e6f5 f6f7",
        rating: 1701,
        themes: ["advancedPawn", "bishopEndgame", "crushing", "endgame", "master", "sacrifice", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1701)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/2q3k1/1p5p/3Pprp1/1PP1Q3/5N1n/5PP1/5K2 w - - 0 34",
        moves: "e4f5 c7c4 f1e1 c4c1 e1e2 h3f4",
        rating: 1740,
        themes: ["crushing", "endgame", "long"],
        description: "Advanced Strategy - Play as White (Rating: 1740)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1p4b1/p5P1/2P4K/PP6/2Pk4/8/8 b - - 0 45",
        moves: "d3c3 b4b5 a6b5 a4b5",
        rating: 910,
        themes: ["bishopEndgame", "crushing", "endgame", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 910)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/5p1p/p3p1p1/2K5/1p3Pk1/1P4P1/P1P4P/8 b - - 0 29",
        moves: "g4h3 c5b4 h3h2 c2c4 h2g3 c4c5",
        rating: 1541,
        themes: ["advantage", "defensiveMove", "endgame", "long", "pawnEndgame", "quietMove"],
        description: "Intermediate Strategy - Play as Black (Rating: 1541)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "5rk1/pp3p1p/8/4Q3/4b3/1P3N2/q1P2PPP/2KR4 w - - 0 19",
        moves: "e5e4 a2a1 c1d2 f8d8",
        rating: 954,
        themes: ["advantage", "endgame", "master", "short"],
        description: "Beginner Strategy - Play as White (Rating: 954)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "5rk1/pp4p1/2p4p/3p4/N2b1nKP/P3QP2/1P5P/8 w - - 0 31",
        moves: "e3d4 h6h5 g4g5 f4e6",
        rating: 1376,
        themes: ["crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1376)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/8/1p5k/1P2K3/1P2bp2/8/8 w - - 0 63",
        moves: "e4e3 h5g4 e3f2 g4f4",
        rating: 1066,
        themes: ["crushing", "defensiveMove", "endgame", "master", "pawnEndgame", "short"],
        description: "Beginner Strategy - Play as White (Rating: 1066)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "3r2k1/R4p1p/R5p1/pr6/3p4/1P5P/P4PP1/6K1 w - - 0 28",
        moves: "a6a5 b5a5 a7a5 d4d3",
        rating: 1210,
        themes: ["crushing", "endgame", "rookEndgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1210)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p5p1/4p3/3pP2p/5PkP/K1P3P1/8/8 b - - 0 42",
        moves: "g4g3 f4f5 e6f5 e5e6 f5f4 e6e7",
        rating: 1441,
        themes: ["advancedPawn", "crushing", "endgame", "long", "master", "pawnEndgame"],
        description: "Intermediate Strategy - Play as Black (Rating: 1441)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/n6p/1p1kPppP/1p1P4/1P2K1PN/8/8 b - - 4 46",
        moves: "a6c7 h3g5 h6g5 h5h6",
        rating: 1412,
        themes: ["crushing", "endgame", "knightEndgame", "master", "sacrifice", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1412)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "1R2Q3/6k1/6pp/8/1pB2KP1/5P2/3r4/4r3 b - - 0 44",
        moves: "e1e8 b8e8 d2d4 e8e4",
        rating: 1565,
        themes: ["advantage", "endgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1565)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "K7/8/3p4/1P1Nb1p1/3p4/3B2k1/5p2/8 b - - 0 55",
        moves: "g3g2 b5b6 f2f1r d3f1 g2f1 b6b7",
        rating: 1634,
        themes: ["advancedPawn", "crushing", "endgame", "long"],
        description: "Advanced Strategy - Play as Black (Rating: 1634)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1p4p1/1P2pk2/8/2P1K3/8/8/8 b - - 0 45",
        moves: "g7g5 c4c5 f6e7 c5c6 b7c6 b6b7",
        rating: 1438,
        themes: ["advancedPawn", "crushing", "endgame", "long", "pawnEndgame", "quietMove"],
        description: "Intermediate Strategy - Play as Black (Rating: 1438)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "5rk1/8/8/p7/1p1PQ1PP/8/1P3rK1/8 w - - 3 43",
        moves: "g2g3 f8f3 e4f3 f2f3 g3f3 a5a4 f3e4 a4a3 b2a3 b4a3",
        rating: 1717,
        themes: ["crushing", "endgame", "queenRookEndgame", "quietMove", "veryLong"],
        description: "Advanced Strategy - Play as White (Rating: 1717)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "1r4k1/5p1p/2Q1p1pb/3pP3/3P4/3qPN1P/5KP1/4R3 w - - 1 27",
        moves: "e1e2 h6e3 e2e3 b8b2",
        rating: 1318,
        themes: ["crushing", "endgame", "master", "sacrifice", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1318)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "6k1/1p3p1p/4p1p1/1RPrP3/P7/7P/6P1/6K1 b - - 0 31",
        moves: "d5e5 c5c6 e5b5 a4b5",
        rating: 1746,
        themes: ["crushing", "endgame", "rookEndgame", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1746)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1qn1Nr1k/6p1/R3Q3/8/1p4P1/4PP1P/6K1 w - - 0 30",
        moves: "e7g6 b3b2 e5h5 h7g7",
        rating: 1460,
        themes: ["advancedPawn", "advantage", "endgame", "master", "masterVsMaster", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1460)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p1b5/2N5/1PK2p2/P3k3/8/8/8 w - - 5 46",
        moves: "c6a7 f5f4 b5b6 c7b6 c5b6 f4f3",
        rating: 1244,
        themes: ["crushing", "endgame", "long", "master", "quietMove", "sacrifice"],
        description: "Intermediate Strategy - Play as White (Rating: 1244)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/R7/1p6/PP4p1/7k/7r/5K2/8 b - - 0 52",
        moves: "b6a5 a7h7 h4g4 h7h3 g4h3 b5b6",
        rating: 1757,
        themes: ["crushing", "endgame", "long", "rookEndgame"],
        description: "Advanced Strategy - Play as Black (Rating: 1757)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p4kB1/p3pN1P/3pPn2/3P2P1/1P2PK2/1r6/8 b - - 0 35",
        moves: "f5g7 h6h7 b2h2 f6h5",
        rating: 1657,
        themes: ["advancedPawn", "crushing", "endgame", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1657)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p5pp/4P3/8/2p2P2/bk1r1P2/4K2P/R7 b - - 0 34",
        moves: "g7g6 a1a3 b3a3 e6e7",
        rating: 1793,
        themes: ["advancedPawn", "advantage", "endgame", "sacrifice", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1793)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/3k2p1/P1pPp2p/4P2P/K5P1/8/5b2 b - - 5 45",
        moves: "c5c4 a5a6 d6c7 d5d6 c7d6 a6a7",
        rating: 1748,
        themes: ["advancedPawn", "bishopEndgame", "crushing", "endgame", "long"],
        description: "Advanced Strategy - Play as Black (Rating: 1748)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "2r3k1/p5pp/4p3/8/8/2p1q3/P1Q1r1PP/B3R2K w - - 0 29",
        moves: "c2e2 e3e2 e1e2 c3c2 e2c2 c8c2",
        rating: 1220,
        themes: ["advancedPawn", "crushing", "endgame", "long", "master"],
        description: "Intermediate Strategy - Play as White (Rating: 1220)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/5kP1/7P/pp1K4/2p5/PP6/8 w - - 0 44",
        moves: "b2c3 b4b3 a2b3 a4a3 c3c4 a3a2",
        rating: 1525,
        themes: ["advancedPawn", "crushing", "endgame", "long", "pawnEndgame"],
        description: "Intermediate Strategy - Play as White (Rating: 1525)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/R4P1p/4p1p1/3pP3/1r1P2PP/1p6/1k1K4/8 b - - 0 40",
        moves: "b4d4 d2e3 d4e4 e3f3",
        rating: 997,
        themes: ["crushing", "defensiveMove", "endgame", "rookEndgame", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 997)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "1r4k1/5pp1/p6p/2P5/4rP2/3R4/6PP/2R3K1 b - - 0 30",
        moves: "e4f4 c5c6 b8c8 c6c7",
        rating: 1237,
        themes: ["advancedPawn", "advantage", "endgame", "rookEndgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1237)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/7p/4p1p1/8/5p2/3K2kP/4R3 w - - 2 58",
        moves: "e1e5 f3f2 e5e2 g2g1",
        rating: 1685,
        themes: ["advancedPawn", "crushing", "endgame", "rookEndgame", "short"],
        description: "Advanced Strategy - Play as White (Rating: 1685)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/6k1/1p1b2p1/1P2pp1p/P1K4P/6P1/4BP2/8 b - - 1 40",
        moves: "d6c5 a4a5 c5f2 a5a6",
        rating: 1526,
        themes: ["bishopEndgame", "crushing", "endgame", "master", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1526)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "1b6/1P6/6p1/4p3/2k1K3/2P3P1/7P/8 b - - 0 41",
        moves: "c4c3 h2h4 c3b4 g3g4 b4c5 h4h5 c5d6 h5h6",
        rating: 1559,
        themes: ["bishopEndgame", "crushing", "endgame", "quietMove", "veryLong"],
        description: "Intermediate Strategy - Play as Black (Rating: 1559)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "2k5/2P3pp/pK1P1p2/1b6/8/8/1B5P/8 b - - 14 47",
        moves: "b5e2 d6d7 c8d7 b6b7 e2f3 b7b8",
        rating: 1411,
        themes: ["advancedPawn", "bishopEndgame", "crushing", "defensiveMove", "endgame", "long", "master"],
        description: "Intermediate Strategy - Play as Black (Rating: 1411)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/pp2r3/7p/P3B1p1/2k1K1P1/3p4/3R4/8 w - - 0 47",
        moves: "e4f5 e7e5 f5e5 c4c3 d2a2 d3d2",
        rating: 1486,
        themes: ["advancedPawn", "crushing", "endgame", "long", "sacrifice"],
        description: "Intermediate Strategy - Play as White (Rating: 1486)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p6p/Pp6/2p2KP1/2P5/1P6/3k4/8 b - - 1 49",
        moves: "d2c2 f5f6 c2b3 f6g7",
        rating: 1157,
        themes: ["crushing", "endgame", "master", "pawnEndgame", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 1157)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/8/4p3/1P6/3k1Kp1/6P1/8 w - - 0 56",
        moves: "f3g3 e5e4 g3f2 d3d2 b4b5 e4e3",
        rating: 1552,
        themes: ["crushing", "endgame", "long", "pawnEndgame", "quietMove"],
        description: "Intermediate Strategy - Play as White (Rating: 1552)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p6p/5p2/1k6/1P2KPp1/2P5/7P/8 w - - 1 43",
        moves: "e4f5 h7h5 f5f6 h5h4 f6g5 g4g3",
        rating: 1687,
        themes: ["crushing", "endgame", "long", "pawnEndgame", "quietMove"],
        description: "Advanced Strategy - Play as White (Rating: 1687)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/6p1/1p2p2p/p2k1pP1/P2P1P1P/1P1K4/8/8 b - - 0 40",
        moves: "h6g5 f4g5 g7g6 h4h5 g6h5 g5g6",
        rating: 1535,
        themes: ["crushing", "endgame", "long", "pawnEndgame"],
        description: "Intermediate Strategy - Play as Black (Rating: 1535)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/6pp/8/p1k1KP1P/P7/8/8 b - - 0 37",
        moves: "c4b3 h4h5 g6h5 f4f5",
        rating: 1715,
        themes: ["crushing", "defensiveMove", "endgame", "pawnEndgame", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1715)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1PK5/2B2kp1/4p3/1r6/8/8/8 w - - 1 57",
        moves: "b7b8q b4b8 c7b8 f6f5",
        rating: 1719,
        themes: ["crushing", "defensiveMove", "endgame", "short"],
        description: "Advanced Strategy - Play as White (Rating: 1719)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1p6/6k1/1PP3p1/1n2p1P1/1Bp1P3/5K2/8 b - - 3 39",
        moves: "c3c2 b3c2 b4c2 c5c6 b7c6 b5c6 c2b4 c6c7",
        rating: 1292,
        themes: ["advancedPawn", "crushing", "endgame", "sacrifice", "veryLong"],
        description: "Intermediate Strategy - Play as Black (Rating: 1292)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1p4qk/p1p4p/3p1P2/3Pp2Q/1P4P1/P4PK1/8 b - - 1 41",
        moves: "g7d4 h4e7 d4g7 f5f6 g7e7 f6e7",
        rating: 1299,
        themes: ["advancedPawn", "crushing", "endgame", "long", "queenEndgame"],
        description: "Intermediate Strategy - Play as Black (Rating: 1299)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "4Nk2/6pp/1p6/2p5/2P5/P2p1PK1/6PP/8 b - - 0 33",
        moves: "f8e8 g3f2 d3d2 f2e2 d2d1q e2d1",
        rating: 1299,
        themes: ["advantage", "endgame", "long", "pawnEndgame"],
        description: "Intermediate Strategy - Play as Black (Rating: 1299)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p1Q2pk1/4p2p/P5pB/6P1/2p4P/3q1K2/8 w - - 18 49",
        moves: "f2f3 d2f4 c7f4 g5f4 f3f4 c3c2",
        rating: 1737,
        themes: ["advancedPawn", "crushing", "endgame", "long"],
        description: "Advanced Strategy - Play as White (Rating: 1737)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/6k1/1p2P1p1/p7/P5PP/2n1Pp2/5P2/5K2 b - - 0 43",
        moves: "c3a4 h4h5 g6h5 g4h5 g7f6 h5h6 f6e6 h6h7",
        rating: 1500,
        themes: ["advancedPawn", "crushing", "endgame", "knightEndgame", "veryLong"],
        description: "Intermediate Strategy - Play as Black (Rating: 1500)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p7/3p2p1/2p1k1P1/1pP2p1P/1P3P2/P2K4/8 b - - 3 36",
        moves: "e5d4 h4h5 g6h5 g5g6 d4e5 g6g7",
        rating: 1191,
        themes: ["advancedPawn", "crushing", "endgame", "long", "pawnEndgame"],
        description: "Beginner Strategy - Play as Black (Rating: 1191)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "6k1/5p1p/4p1p1/1q1pP3/2rP4/1p1N3P/1Q1B1PPK/8 w - - 0 42",
        moves: "d3c1 c4c2 b2b3 b5b3 c1b3 c2b2",
        rating: 1614,
        themes: ["crushing", "endgame", "long"],
        description: "Advanced Strategy - Play as White (Rating: 1614)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "3k4/8/2P5/p2K2p1/Pp3p1p/1P3P1P/8/8 w - - 1 53",
        moves: "d5c5 g5g4 f3g4 f4f3",
        rating: 1665,
        themes: ["crushing", "endgame", "pawnEndgame", "short"],
        description: "Advanced Strategy - Play as White (Rating: 1665)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/2P1N1p1/7p/5R2/6k1/P1K2p2/3r4 b - - 2 44",
        moves: "f2f1q f4f1 d1f1 c6c7",
        rating: 935,
        themes: ["advancedPawn", "crushing", "endgame", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 935)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/4k3/5p1p/1p1P1K2/1P4P1/8/8 w - - 0 43",
        moves: "f4e3 e6d5 e3d3 f5f4 g3f4 h5h4",
        rating: 1533,
        themes: ["crushing", "defensiveMove", "endgame", "long", "pawnEndgame", "zugzwang"],
        description: "Intermediate Strategy - Play as White (Rating: 1533)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p2r1p2/7p/6p1/4Pk2/5P1P/PR1p2P1/3K4 w - - 1 35",
        moves: "b2d2 d7d2 d1d2 f4g3",
        rating: 1012,
        themes: ["crushing", "endgame", "rookEndgame", "short"],
        description: "Beginner Strategy - Play as White (Rating: 1012)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "6b1/8/4pP1p/1p1kP1pP/p1pPp1K1/P1P1P3/8/3N4 w - - 0 50",
        moves: "d1f2 b5b4 c3b4 c4c3 f2d1 c3c2 d1c3 d5c4",
        rating: 1398,
        themes: ["advancedPawn", "crushing", "endgame", "veryLong"],
        description: "Intermediate Strategy - Play as White (Rating: 1398)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/7p/3p1ppk/2bP4/P1pNKPP1/7P/8 w - - 2 42",
        moves: "d3e5 f5f4 g3f4 g5f4 e3f4 c3c2",
        rating: 1741,
        themes: ["advancedPawn", "crushing", "endgame", "long"],
        description: "Advanced Strategy - Play as White (Rating: 1741)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/2B5/4k1K1/1p6/p1p5/P1Pn3P/8/8 w - - 2 43",
        moves: "h3h4 b5b4 c3b4 c4c3",
        rating: 1755,
        themes: ["crushing", "endgame", "master", "short"],
        description: "Advanced Strategy - Play as White (Rating: 1755)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "4k3/R4pK1/8/8/8/7r/P7/8 w - - 4 61",
        moves: "a7f7 h3g3 g7f6 g3f3",
        rating: 984,
        themes: ["crushing", "endgame", "rookEndgame", "short"],
        description: "Beginner Strategy - Play as White (Rating: 984)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/4k3/8/1pK1pPp1/3p2Pp/P2P3P/1P6/8 w - - 1 40",
        moves: "c5b5 e5e4 d3e4 d4d3 b5c4 d3d2",
        rating: 1438,
        themes: ["advancedPawn", "crushing", "endgame", "long", "pawnEndgame"],
        description: "Intermediate Strategy - Play as White (Rating: 1438)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "3r2k1/p4ppp/8/1p6/8/PNnB1P2/b1P3PP/2K4R b - - 1 23",
        moves: "d8d3 c2d3 a2b3 c1b2",
        rating: 1496,
        themes: ["advantage", "endgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1496)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "r3k3/1R2rppp/P3p3/3p4/8/5P2/5P1P/1R4K1 b - - 6 30",
        moves: "a8a6 b7b8 e8d7 b1b7 d7d6 b8d8",
        rating: 1341,
        themes: ["advantage", "endgame", "long", "rookEndgame"],
        description: "Intermediate Strategy - Play as Black (Rating: 1341)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/5p2/6p1/2KpP1P1/P2P4/4Bpk1/4b3/8 b - - 3 53",
        moves: "f3f2 e3f2 g3f2 c5d5",
        rating: 1634,
        themes: ["bishopEndgame", "crushing", "endgame", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1634)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "2R5/1p4p1/1Pb1pk1p/5p2/8/3B1PP1/4P1KP/r7 b - - 2 33",
        moves: "e6e5 c8c6 b7c6 b6b7",
        rating: 1629,
        themes: ["advancedPawn", "crushing", "endgame", "sacrifice", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1629)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "2r5/1pn2R1p/1P2k3/p7/8/1P5P/3K4/8 w - - 0 38",
        moves: "f7c7 c8c7 b6c7 e6d7 c7c8b d7c8",
        rating: 1599,
        themes: ["crushing", "endgame", "long", "rookEndgame"],
        description: "Intermediate Strategy - Play as White (Rating: 1599)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p5p1/1p5p/1Pk2P1P/P1P3P1/1K6/8/4b3 b - - 2 55",
        moves: "e1b4 g4g5 h6g5 f5f6 g7f6 h5h6",
        rating: 1596,
        themes: ["bishopEndgame", "crushing", "endgame", "long", "sacrifice"],
        description: "Intermediate Strategy - Play as Black (Rating: 1596)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "6r1/pp1k4/3qpp2/7p/2pP2rP/P1P1Q1P1/1P3P2/3RR1K1 w - - 4 24",
        moves: "e3f3 g4g3 f2g3 g8g3",
        rating: 960,
        themes: ["advantage", "endgame", "kingsideAttack", "sacrifice", "short"],
        description: "Beginner Strategy - Play as White (Rating: 960)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/7k/6pP/4KpP1/4p3/4P3/8/8 b - - 2 55",
        moves: "h7g8 e5f6 g8h7 f6f7 f5f4 e3f4 e4e3 f4f5 g6f5 g5g6 h7h6 g6g7",
        rating: 1265,
        themes: ["advancedPawn", "crushing", "endgame", "exposedKing", "pawnEndgame", "veryLong"],
        description: "Intermediate Strategy - Play as Black (Rating: 1265)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "1k3r2/ppp1Q2B/8/8/2P3PP/8/PP1n1q2/1K1R4 w - - 3 28",
        moves: "d1d2 f2f1 b1c2 f1c4 c2d1 f8f1",
        rating: 1256,
        themes: ["advantage", "endgame", "long"],
        description: "Intermediate Strategy - Play as White (Rating: 1256)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "5Q2/8/8/8/pPk5/P7/3p1Kp1/8 b - - 0 52",
        moves: "g2g1q f2g1 d2d1q f8f1 d1f1 g1f1",
        rating: 934,
        themes: ["crushing", "endgame", "long", "queenEndgame"],
        description: "Beginner Strategy - Play as Black (Rating: 934)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "2r3k1/pp1r1p1p/1n4p1/5N2/2B5/1P5P/P4PP1/R3R1K1 b - - 0 22",
        moves: "b6c4 f5e7 d7e7 e1e7",
        rating: 1681,
        themes: ["endgame"],
        description: "Advanced Strategy - Play as Black (Rating: 1681)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/5p2/p3p3/4P3/1PK2k1p/7P/5P2/8 b - - 0 58",
        moves: "f4e5 c4c5 f7f5 c5b6",
        rating: 1286,
        themes: ["crushing", "endgame", "pawnEndgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1286)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "1kbN4/8/1P2p1pp/2KpPp2/2p2P2/2P5/6PP/8 w - - 3 49",
        moves: "c5c6 d5d4 c3d4 c4c3",
        rating: 1626,
        themes: ["advantage", "endgame", "master", "short"],
        description: "Advanced Strategy - Play as White (Rating: 1626)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "6k1/p2p2p1/1p1p3p/n1rP4/2P1N2Q/P1Pq4/6PP/5RK1 b - - 5 25",
        moves: "c5c4 h4d8 g8h7 e4f6",
        rating: 1365,
        themes: ["advantage", "endgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1365)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/4k3/1p1p3p/p2PP1P1/P4K2/1P6/8 b - - 0 44",
        moves: "h5g4 f3g4 d5e4 g4f4 e6d5 f4e3",
        rating: 1134,
        themes: ["crushing", "endgame", "long", "pawnEndgame", "zugzwang"],
        description: "Beginner Strategy - Play as Black (Rating: 1134)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "5r2/p1p3k1/1b4p1/8/8/1P1q1N1P/P3R1P1/4QK2 w - - 7 35",
        moves: "e1d2 f8f3 g2f3 d3f3",
        rating: 1387,
        themes: ["crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1387)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/1p1bk3/p5K1/P2p1p2/1P1N1P2/8/8 w - - 8 54",
        moves: "d3f4 d6f4 g5f4 e6d5",
        rating: 1580,
        themes: ["crushing", "defensiveMove", "endgame", "short", "zugzwang"],
        description: "Intermediate Strategy - Play as White (Rating: 1580)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "3k4/r2P3p/3R2p1/4K3/8/7P/6P1/8 b - - 6 40",
        moves: "a7d7 d6d7 d8d7 e5f6 d7e8 f6g7",
        rating: 1275,
        themes: ["crushing", "endgame", "long", "rookEndgame"],
        description: "Intermediate Strategy - Play as Black (Rating: 1275)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/2PK3k/8/6p1/8/2r5/7p/3R4 w - - 0 55",
        moves: "c7c8q c3c8 d7c8 g5g4",
        rating: 1366,
        themes: ["crushing", "defensiveMove", "endgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1366)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "6k1/6p1/p1q5/8/1p1p4/1P1P1p1p/P1P2Q1P/6K1 w - - 0 37",
        moves: "f2d4 c6g6 g1f2 g6g2",
        rating: 1375,
        themes: ["crushing", "endgame", "master", "queenEndgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1375)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/5Qpk/2p4p/8/pP3P2/q1P3P1/4R1KP/3r4 b - - 0 35",
        moves: "a3c3 f7f5 g7g6 e2e7",
        rating: 1415,
        themes: ["crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1415)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/PK6/1n3p2/2k3p1/6P1/5P1P/8/8 w - - 0 54",
        moves: "a7a8q b6a8 b7a8 c5d4 a8b7 d4e3 b7c8 e3f3",
        rating: 1248,
        themes: ["crushing", "endgame", "veryLong"],
        description: "Intermediate Strategy - Play as White (Rating: 1248)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p7/1p1p4/3P2p1/1PP2k1p/8/P4KP1/8 b - - 0 37",
        moves: "g5g4 c4c5 d6c5 d5d6 c5c4 d6d7",
        rating: 1566,
        themes: ["advancedPawn", "crushing", "endgame", "long", "pawnEndgame"],
        description: "Intermediate Strategy - Play as Black (Rating: 1566)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/5k2/3p3R/2n2B2/7P/2p1P1P1/6K1/3r4 w - - 1 38",
        moves: "g2f3 d1f1 f3g4 f1f5 g4f5 c3c2",
        rating: 1631,
        themes: ["advancedPawn", "crushing", "endgame", "long", "sacrifice"],
        description: "Advanced Strategy - Play as White (Rating: 1631)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/1p3p2/6p1/1kP4p/3KPP1P/8/8 w - - 5 43",
        moves: "d3d4 f6f5 f3f4 g5g4 h3g4 h4h3",
        rating: 1797,
        themes: ["crushing", "endgame", "long", "pawnEndgame", "quietMove"],
        description: "Advanced Strategy - Play as White (Rating: 1797)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/4Pk2/p7/P1B3p1/4p1Kp/8/8/8 w - - 1 44",
        moves: "g4g5 h4h3 c5g1 e4e3 g1e3 h3h2",
        rating: 1383,
        themes: ["advancedPawn", "bishopEndgame", "crushing", "endgame", "long"],
        description: "Intermediate Strategy - Play as White (Rating: 1383)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/2p5/1p1p3p/1P1P4/2Pk2PK/8/8/8 b - - 6 46",
        moves: "d4c4 h4h5 c4b5 h5h6 b5c4 g4g5",
        rating: 1095,
        themes: ["crushing", "defensiveMove", "endgame", "long", "pawnEndgame"],
        description: "Beginner Strategy - Play as Black (Rating: 1095)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/3k3p/p4p2/Kp3P2/2p5/7P/PP6/8 w - - 2 50",
        moves: "a5a6 b5b4 a6b5 c4c3 b2c3 b4c3 b5c4 c3c2",
        rating: 1505,
        themes: ["advancedPawn", "crushing", "endgame", "pawnEndgame", "quietMove", "veryLong"],
        description: "Intermediate Strategy - Play as White (Rating: 1505)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/6R1/p6p/1r5P/1k3PK1/8/8 w - - 1 46",
        moves: "g6g5 a5a4 g5h5 a4a3 h5e5 a3a2",
        rating: 1212,
        themes: ["advancedPawn", "crushing", "endgame", "long", "quietMove", "rookEndgame"],
        description: "Intermediate Strategy - Play as White (Rating: 1212)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/8/3p1pR1/1K1PbB1r/4Pk2/8/8 w - - 0 50",
        moves: "b4c5 h4f4 e3f4 f3f4 g5g1 f4e3",
        rating: 1439,
        themes: ["crushing", "endgame", "long"],
        description: "Intermediate Strategy - Play as White (Rating: 1439)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "1r5k/6pp/2Pbpp2/1P6/p7/P1N1R2P/1n4P1/7K b - - 2 40",
        moves: "d6e5 e3e5 f6e5 c6c7 b8g8 b5b6 b2c4 b6b7",
        rating: 1641,
        themes: ["advancedPawn", "crushing", "endgame", "sacrifice", "veryLong"],
        description: "Advanced Strategy - Play as Black (Rating: 1641)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/p1B2k2/3Pb2p/4P3/4B2P/r7/4K3/8 b - - 0 42",
        moves: "a3a1 e4d5 e6d5 d6d7",
        rating: 1611,
        themes: ["advancedPawn", "crushing", "endgame", "master", "sacrifice", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1611)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/6k1/6p1/N7/3K1Ppp/1PR3Pr/8/8 w - - 0 47",
        moves: "g3h4 h3c3 d4c3 g4g3 a5c4 g3g2",
        rating: 1283,
        themes: ["advancedPawn", "advantage", "endgame", "long"],
        description: "Intermediate Strategy - Play as White (Rating: 1283)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/pp1Qnk2/8/2p1p3/2P1Pp2/P1P5/1PK5/6r1 w - - 4 37",
        moves: "d7b7 f4f3 b7b8 f3f2",
        rating: 1484,
        themes: ["advancedPawn", "crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1484)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/2K4k/5p2/1p4pp/1P1Bp3/6P1/8/8 w - - 0 53",
        moves: "c7b6 h5h4 g3h4 g5h4 b6b5 h4h3 d4g1 e4e3",
        rating: 1529,
        themes: ["bishopEndgame", "crushing", "endgame", "master", "veryLong"],
        description: "Intermediate Strategy - Play as White (Rating: 1529)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1r3p2/8/8/2R5/4P3/pp1RK1PP/1k6 b - - 1 50",
        moves: "a2a1q d2d1 b1a2 c4a4",
        rating: 1275,
        themes: ["crushing", "endgame", "queenRookEndgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1275)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "R7/1P4kp/6p1/3n1pP1/7P/3p1Pb1/8/5K2 w - - 0 42",
        moves: "b7b8q d5e3 f1g1 g3b8 a8b8 d3d2",
        rating: 1675,
        themes: ["advancedPawn", "crushing", "endgame", "long"],
        description: "Advanced Strategy - Play as White (Rating: 1675)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/p2k3p/1b1p2pP/1P1Kp1P1/1BP5/8/8 w - - 3 65",
        moves: "b3d5 e4e3 c3c4 e3e2",
        rating: 1307,
        themes: ["advancedPawn", "bishopEndgame", "crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1307)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "1r4k1/5p1p/2RNpqp1/p2p4/P2b4/1P4P1/2Q2P1P/6K1 b - - 5 29",
        moves: "b8b3 c6c8 g8g7 d6e8",
        rating: 1204,
        themes: ["crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1204)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/5kpp/8/2P1pP2/1R1Br2P/5K2/8 b - - 0 36",
        moves: "e3d3 b3d3 e4d3 f2e3 d3d2 e3d2",
        rating: 1544,
        themes: ["crushing", "endgame", "long", "rookEndgame"],
        description: "Intermediate Strategy - Play as Black (Rating: 1544)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1pp5/8/1P3k2/P3pP2/8/6K1/8 b - - 0 41",
        moves: "f5f4 a4a5 f4e3 a5a6 b7a6 b5a6",
        rating: 1744,
        themes: ["crushing", "endgame", "long", "pawnEndgame", "quietMove"],
        description: "Advanced Strategy - Play as Black (Rating: 1744)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/5p2/3p4/2nP1PPp/1kP5/1P6/4K3/8 b - - 0 42",
        moves: "b4b3 g5g6 f7g6 f5g6 b3c4 g6g7",
        rating: 911,
        themes: ["advancedPawn", "advantage", "endgame", "knightEndgame", "long"],
        description: "Beginner Strategy - Play as Black (Rating: 911)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "1R6/8/8/8/P3p3/1Pk5/1r6/3K4 b - - 11 59",
        moves: "b2b3 b8b3 c3b3 a4a5",
        rating: 1110,
        themes: ["crushing", "defensiveMove", "endgame", "rookEndgame", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 1110)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/7p/6p1/8/4KP2/6P1/6kP/8 b - - 9 47",
        moves: "g2h2 g3g4 h2h3 f4f5 h3g4 f5f6",
        rating: 1684,
        themes: ["crushing", "endgame", "long", "pawnEndgame", "quietMove"],
        description: "Advanced Strategy - Play as Black (Rating: 1684)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/4p3/1K2p3/7p/k6P/P5P1/8 b - - 0 48",
        moves: "a3a2 b5c4 a2b1 c4d3",
        rating: 1705,
        themes: ["crushing", "defensiveMove", "endgame", "pawnEndgame", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1705)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "2r5/k6p/P3pp2/1P1p3b/5P2/4P2P/3K2P1/R7 b - - 0 29",
        moves: "c8c5 b5b6 a7b6 a6a7",
        rating: 1221,
        themes: ["advancedPawn", "crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1221)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/4k3/1R2P3/1B1p2pp/5p2/1r5P/5K2/8 b - - 5 53",
        moves: "b3h3 b6b7 e7e6 b5d7",
        rating: 1006,
        themes: ["crushing", "endgame", "master", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 1006)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/Pk6/3K1p2/4p1pp/8/5PPP/8 w - - 0 45",
        moves: "d5e5 g4g3 h2g3 h4g3 f2g3 e4e3",
        rating: 1713,
        themes: ["crushing", "endgame", "long", "pawnEndgame"],
        description: "Advanced Strategy - Play as White (Rating: 1713)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/5p2/8/p5pp/6k1/PP4P1/4K2P/8 b - - 2 50",
        moves: "g4h3 b3b4 a5b4 a3b4 h3h2 b4b5",
        rating: 1352,
        themes: ["crushing", "defensiveMove", "endgame", "long", "pawnEndgame"],
        description: "Intermediate Strategy - Play as Black (Rating: 1352)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "5k2/8/6RP/p3K3/P1r5/8/8/8 b - - 0 58",
        moves: "c4a4 h6h7 a4h4 g6g8",
        rating: 1320,
        themes: ["advancedPawn", "crushing", "endgame", "rookEndgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1320)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/4nB2/1p1k1Kp1/6Pp/7P/8/8 w - - 0 61",
        moves: "f6g5 e6g5 f5g5 b5b4",
        rating: 1376,
        themes: ["crushing", "defensiveMove", "endgame", "master", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1376)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "3r4/p7/4pkp1/3r3p/3pKP1P/PP1R4/8/3R4 w - - 0 35",
        moves: "d3d4 d5d4 d1d4 d8d4 e4d4 f6f5",
        rating: 1464,
        themes: ["crushing", "endgame", "long", "rookEndgame"],
        description: "Intermediate Strategy - Play as White (Rating: 1464)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/R7/6p1/6K1/1r3P2/1k5P/p7/8 w - - 0 65",
        moves: "g5g6 b4a4 a7a4 b3a4",
        rating: 1488,
        themes: ["crushing", "endgame", "rookEndgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1488)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/2K5/5p2/4k3/1P2P3/3B4/3n4/8 b - - 2 55",
        moves: "d2e4 d3e4 e5e4 b4b5",
        rating: 882,
        themes: ["crushing", "defensiveMove", "endgame", "master", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 882)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/5pk1/P5p1/2q1P3/2pp1Q2/7P/6P1/7K b - - 2 41",
        moves: "c5b6 f4f6 b6f6 e5f6 g7f6 a6a7",
        rating: 976,
        themes: ["advancedPawn", "crushing", "endgame", "long", "queenEndgame"],
        description: "Beginner Strategy - Play as Black (Rating: 976)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "r5k1/1p3pp1/p6p/4B3/P1PQ2P1/3b3q/1P3R2/6K1 w - - 0 30",
        moves: "e5g7 h3g3 f2g2 g3e1 g1h2 e1h4",
        rating: 1405,
        themes: ["crushing", "endgame", "exposedKing", "long"],
        description: "Intermediate Strategy - Play as White (Rating: 1405)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/6bk/4p1pp/4P3/pn1PP1PN/1p1KB3/1P6/8 w - - 2 37",
        moves: "d3c4 a4a3 b2a3 b3b2",
        rating: 1739,
        themes: ["advancedPawn", "crushing", "endgame", "short"],
        description: "Advanced Strategy - Play as White (Rating: 1739)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "1r6/5p2/p2kp3/3p3R/8/1pPbPN2/P2K1PP1/8 w - - 0 34",
        moves: "d2d3 b3a2 h5h1 b8b1",
        rating: 1235,
        themes: ["advancedPawn", "crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1235)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "4r1k1/1p1R2pp/p7/3P1n2/5q2/2Q2N1P/PP4P1/7K w - - 9 29",
        moves: "d7b7 f5g3 h1g1 g3e2",
        rating: 1356,
        themes: ["crushing", "endgame", "master", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1356)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/7p/6pk/1P6/5p1P/2Q5/5qP1/7K b - - 2 41",
        moves: "f2h4 c3h3 h4h3 g2h3",
        rating: 1029,
        themes: ["crushing", "endgame", "master", "queenEndgame", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 1029)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "5rk1/1pR2pp1/3R2np/pP6/P3r3/6P1/1B3PP1/6K1 b - - 1 28",
        moves: "e4a4 d6g6 f7g6 c7g7",
        rating: 1404,
        themes: ["crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1404)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "2r3k1/5pp1/7p/8/P3b1P1/5QKP/5P2/R1RNq3 b - - 0 31",
        moves: "e4f3 c1c8 g8h7 g3f3",
        rating: 1195,
        themes: ["advantage", "endgame", "hangingPiece", "intermezzo", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 1195)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/6bk/1pp1Q1pp/3n4/P2P2P1/1Pq4P/6B1/4R2K w - - 3 37",
        moves: "g2d5 c3h3 h1g1 g7d4",
        rating: 1380,
        themes: ["crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as White (Rating: 1380)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1p6/4p3/4p3/pP2k1p1/P3p1K1/2P1N2p/8 w - - 0 51",
        moves: "g3h2 e4f3 e2g1 f3f2",
        rating: 1167,
        themes: ["crushing", "defensiveMove", "endgame", "knightEndgame", "short"],
        description: "Beginner Strategy - Play as White (Rating: 1167)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "5r2/2p5/p2p2kp/P3pR2/1P3pP1/2P2K2/8/8 b - - 2 38",
        moves: "f8f5 g4f5 g6f5 b4b5",
        rating: 1476,
        themes: ["crushing", "endgame", "short"],
        description: "Intermediate Strategy - Play as Black (Rating: 1476)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/2k5/K7/1P4p1/5p1p/5P1P/8/8 w - - 1 57",
        moves: "b5b6 c7b8 a6b5 g5g4 h3g4 h4h3 g4g5 h3h2",
        rating: 1489,
        themes: ["advancedPawn", "crushing", "defensiveMove", "endgame", "pawnEndgame", "veryLong"],
        description: "Intermediate Strategy - Play as White (Rating: 1489)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1R4p1/4p2k/4P2P/6K1/1p3P2/8/1r6 w - - 1 38",
        moves: "b7b6 b3b2 b6e6 h6h7 e6b6 b1g1",
        rating: 1663,
        themes: ["advancedPawn", "crushing", "endgame", "long", "rookEndgame"],
        description: "Advanced Strategy - Play as White (Rating: 1663)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/2k4p/pR4p1/2P2p2/1P2p3/K7/2b4P/8 w - - 3 52",
        moves: "b6a6 e4e3 a3b2 e3e2 a6a1 c2d1",
        rating: 1610,
        themes: ["advancedPawn", "advantage", "defensiveMove", "endgame", "long"],
        description: "Advanced Strategy - Play as White (Rating: 1610)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/1p6/p2p4/P2P4/1pP5/2K1k3/8/8 w - - 0 46",
        moves: "c3b4 e3d4 b4b3 d4c5",
        rating: 1231,
        themes: ["crushing", "endgame", "pawnEndgame", "short", "zugzwang"],
        description: "Intermediate Strategy - Play as White (Rating: 1231)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'strategy' as const
    },
    {
        fen: "2r3k1/r5p1/2nR2Np/ppp5/6P1/P7/1P3P1P/4R1K1 b - - 3 30",
        moves: "g8f7 d6c6 c8c6 g6e5",
        rating: 1668,
        themes: ["crushing", "endgame", "master", "sacrifice", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1668)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/6p1/8/p4p1p/1kPp1P2/1P1K2PP/8/8 b - - 6 44",
        moves: "b4b3 c4c5 a5a4 c5c6 a4a3 c6c7",
        rating: 1196,
        themes: ["advancedPawn", "crushing", "endgame", "long", "pawnEndgame", "quietMove"],
        description: "Beginner Strategy - Play as Black (Rating: 1196)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "3r4/5k2/8/R5pP/P3pp2/1P1p2P1/1P1K1P2/8 w - - 0 43",
        moves: "a5g5 e4e3 f2e3 f4e3 d2e3 d3d2",
        rating: 1104,
        themes: ["advancedPawn", "advantage", "endgame", "exposedKing", "long", "rookEndgame"],
        description: "Beginner Strategy - Play as White (Rating: 1104)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/2k5/8/p4R2/4p1K1/r5P1/5P2/8 w - - 1 56",
        moves: "g4f4 a3f3 f4e4 f3f5 e4f5 a5a4",
        rating: 1058,
        themes: ["crushing", "defensiveMove", "endgame", "long", "rookEndgame"],
        description: "Beginner Strategy - Play as White (Rating: 1058)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "5r2/8/8/2p2R2/5rKP/3k4/8/8 w - - 0 56",
        moves: "f5f4 f8f4 g4f4 c5c4",
        rating: 1095,
        themes: ["crushing", "defensiveMove", "endgame", "rookEndgame", "short"],
        description: "Beginner Strategy - Play as White (Rating: 1095)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/6N1/p1p1n3/2k1P2P/8/8/1pK5/8 b - - 0 57",
        moves: "e6g7 h5h6 g7e6 h6h7 b2b1b c2b1",
        rating: 980,
        themes: ["advancedPawn", "crushing", "endgame", "knightEndgame", "long"],
        description: "Beginner Strategy - Play as Black (Rating: 980)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/8/1pKP4/p1p5/P1P5/1k6/8 b - - 0 60",
        moves: "b2c3 d5d6 c3b3 d6d7",
        rating: 1021,
        themes: ["advancedPawn", "crushing", "endgame", "master", "pawnEndgame", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 1021)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "3r2k1/2p2ppp/p7/8/Pb2b3/4BN1P/1P3PP1/2R3K1 w - - 0 26",
        moves: "c1c7 d8d1 g1h2 b4d6",
        rating: 959,
        themes: ["crushing", "endgame", "master", "masterVsMaster", "short"],
        description: "Beginner Strategy - Play as White (Rating: 959)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/8/p2kp2p/1p1n2pP/1P1P2P1/P4K2/8/2B5 b - - 3 40",
        moves: "d5c3 c1g5 h6g5 h5h6",
        rating: 1709,
        themes: ["crushing", "endgame", "sacrifice", "short"],
        description: "Advanced Strategy - Play as Black (Rating: 1709)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'strategy' as const
    },
    {
        fen: "8/6kp/2P5/1P2p3/4P2p/4K2P/1P1r2P1/8 b - - 6 42",
        moves: "d2b2 c6c7 b2c2 b5b6",
        rating: 994,
        themes: ["advancedPawn", "crushing", "endgame", "rookEndgame", "short"],
        description: "Beginner Strategy - Play as Black (Rating: 994)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'strategy' as const
    },
    {
        fen: "r1bq1rk1/ppp2p2/2np4/3np1B1/2B1P3/P2P4/1PP2bPP/R2Q1K1R w - - 0 13",
        moves: "g5d8 d5e3 f1f2 e3d1",
        rating: 854,
        themes: ["advantage", "fork", "opening", "short"],
        description: "Beginner Opening - Play as White - Fork (Rating: 854)",
        hint: "Attack multiple pieces at once!",
        complexity: 'beginner' as const,
        category: 'opening' as const
    },
    {
        fen: "1rbqk1nr/p2pppbp/2p3p1/8/2P5/6P1/PP2PPBP/RNBQ1RK1 b k - 2 8",
        moves: "g7b2 c1b2 b8b2 d1d4",
        rating: 1350,
        themes: ["crushing", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1350)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rn2k1nr/pQp2pbp/6p1/2q5/8/4P3/PP3PPP/RNB1K1NR w KQkq - 1 10",
        moves: "b7a8 c5c1 e1e2 c1b2",
        rating: 1597,
        themes: ["advantage", "hangingPiece", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1597)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r2qk2r/ppp2pp1/3b3p/4p3/2BN1n2/P2P3b/1PPN1PP1/R1BQ1RK1 w kq - 0 11",
        moves: "g2h3 d8g5 d1g4 f4h3",
        rating: 1621,
        themes: ["crushing", "intermezzo", "kingsideAttack", "opening", "pin", "short"],
        description: "Advanced Opening - Play as White - Pin (Rating: 1621)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b2rk1/pp1p2pp/2p2n2/4b3/1q6/2NBP3/PPPQ1PPP/R1B1K2R w KQ - 0 12",
        moves: "e1g1 e5h2 g1h2 b4h4 h2g1 f6g4",
        rating: 1742,
        themes: ["attraction", "crushing", "kingsideAttack", "long", "opening", "sacrifice"],
        description: "Advanced Opening - Play as White (Rating: 1742)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "rn1qk2r/pp2bppp/2p1pn2/4N3/3P1B2/8/PPP1N1PP/R2Q1RK1 b kq - 0 10",
        moves: "f6d5 e5f7 e8f7 f4c7",
        rating: 1528,
        themes: ["attackingF2F7", "crushing", "discoveredAttack", "discoveredCheck", "opening", "sacrifice", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1528)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r2qr1k1/pp3ppp/2n1b3/2Npp3/7N/2P1P1nP/PP2BPP1/R2QK2R w KQ - 0 14",
        moves: "c5e6 d8h4 f2g3 h4g3",
        rating: 1664,
        themes: ["advantage", "opening", "short"],
        description: "Advanced Opening - Play as White (Rating: 1664)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "rnbqkbnr/1p1p2pp/p4p2/4N3/4P3/4B3/PPP2PPP/RN1QKB1R b KQkq - 0 7",
        moves: "f6e5 d1h5 g7g6 h5e5",
        rating: 973,
        themes: ["crushing", "opening", "short"],
        description: "Beginner Opening - Play as Black (Rating: 973)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'opening' as const
    },
    {
        fen: "rn2kbnr/pQp2qpp/8/5b2/8/2N1p3/PP1P1PPP/R1B1K1NR w KQkq - 0 9",
        moves: "b7a8 e3f2 e1f2 f5e4",
        rating: 1536,
        themes: ["advancedPawn", "attackingF2F7", "crushing", "discoveredAttack", "discoveredCheck", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1536)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r3kbnr/pp3ppp/8/q2Nnp2/8/2P1B3/PP2BPPP/R2QK2R b KQkq - 0 11",
        moves: "a8d8 e2b5 a5b5 d5c7",
        rating: 1545,
        themes: ["advantage", "opening", "sacrifice", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1545)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bq1rk1/ppnn1ppp/2p1pb2/2P1N3/PP1p1P2/3P2P1/1B2P1BP/RN1Q1RK1 w - - 0 14",
        moves: "b2d4 d7e5 d4e5 f6e5 f4e5 d8d4",
        rating: 1360,
        themes: ["advantage", "long", "opening"],
        description: "Intermediate Opening - Play as White (Rating: 1360)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bq1rk1/1p1pbpp1/p1n2n1p/1N1Np3/1P2P3/P2BB3/2P2PPP/R2Q1RK1 b - - 2 12",
        moves: "a6b5 e3b6 d8e8 d5c7",
        rating: 1775,
        themes: ["advantage", "opening", "short"],
        description: "Advanced Opening - Play as Black (Rating: 1775)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r3k1nr/pp1n2p1/2pbpq1p/3pN3/3P4/2P5/PP3PPP/RNBQR1K1 b kq - 2 11",
        moves: "d7e5 d4e5 d6e5 d1h5",
        rating: 1643,
        themes: ["advantage", "fork", "opening", "short"],
        description: "Advanced Opening - Play as Black - Fork (Rating: 1643)",
        hint: "Attack multiple pieces at once!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b2k1r/pp3pbp/1q1p2p1/5nB1/3N4/1P5P/P2NQPP1/R3KB1R b KQ - 0 15",
        moves: "f5d4 e2e7 f8g8 e7e8",
        rating: 1077,
        themes: ["advantage", "opening", "short"],
        description: "Beginner Opening - Play as Black (Rating: 1077)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'opening' as const
    },
    {
        fen: "rnb1k2r/pppp1ppp/4p3/4P1q1/3Pn1Q1/8/PPP2PPP/RN2KBNR w KQkq - 2 7",
        moves: "g4e4 g5c1 e1e2 c1b2",
        rating: 1404,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1404)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "1r1q1bnr/p2b1ppp/Nk6/8/2p1QB2/8/PP2PPPP/R3KBNR w KQ - 7 13",
        moves: "a6b8 f8b4 f4d2 b4d2",
        rating: 1218,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1218)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "1brr2k1/1pqb1ppp/p4n2/2Ppn3/8/PPN2N1P/1B2BPP1/2RQR1K1 w - - 0 17",
        moves: "c3d5 e5f3 e2f3 c7h2",
        rating: 1667,
        themes: ["clearance", "crushing", "kingsideAttack", "opening", "short"],
        description: "Advanced Opening - Play as White (Rating: 1667)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "rn1qkb1r/p2p1ppp/b1p5/8/Q1p1N3/4P3/PP1P1PPP/R1B1KB1R w KQkq - 0 9",
        moves: "f1c4 a6c4 a4c4 d7d5",
        rating: 1300,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1300)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r2qkbnr/1p1b2pp/p1nppp2/3N2B1/4P2N/8/PP2BPPP/R2Q1RK1 b kq - 1 10",
        moves: "f6g5 e2h5 g7g6 h4g6",
        rating: 1457,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1457)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b1k1nr/pppp1pp1/2nb2qp/1B2p1B1/4P2P/3P1N2/PPP2PP1/RN1QK2R w KQkq - 0 7",
        moves: "h4h5 h6g5 h5g6 h8h1",
        rating: 1659,
        themes: ["opening"],
        description: "Advanced Opening - Play as White (Rating: 1659)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "rn3rk1/pp1bnppp/4p3/q1ppP3/P2P4/2PB1N2/2PB1PPP/R2QK2R b KQ - 6 10",
        moves: "c5c4 d3h7 g8h7 f3g5 h7g8 d1h5",
        rating: 1166,
        themes: ["attraction", "clearance", "crushing", "kingsideAttack", "long", "opening", "sacrifice"],
        description: "Beginner Opening - Play as Black (Rating: 1166)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b1kb1r/p1qp1ppp/2n1p3/1pp1P3/2N3n1/3P1N1P/PPP1QPP1/R1B1KB1R b KQkq - 0 8",
        moves: "g4f2 c4d6 f8d6 e5d6",
        rating: 1561,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1561)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r3k1nr/ppp2ppp/1bp2q2/4P3/3P2b1/5N2/PP3PPP/RNBQ1RK1 b kq - 0 9",
        moves: "g4f3 e5f6 f3d1 f6g7",
        rating: 1680,
        themes: ["advancedPawn", "crushing", "opening", "short"],
        description: "Advanced Opening - Play as Black (Rating: 1680)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "2kr1b1r/pppq1ppp/2b2n2/8/3NP3/P1N1B3/1PP3PP/R2Q1RK1 b - - 0 12",
        moves: "f6e4 d4c6 d7c6 d1g4",
        rating: 1559,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1559)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "1r1q1rk1/p1pn1ppp/2Qb1n2/3p4/6P1/P1N1PB1P/1P1P1P2/R1B1K2R w KQ - 1 14",
        moves: "c3d5 d7e5 d5f6 d8f6",
        rating: 1787,
        themes: ["advantage", "fork", "master", "opening", "short"],
        description: "Advanced Opening - Play as White - Fork (Rating: 1787)",
        hint: "Attack multiple pieces at once!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b2rk1/p2nqppp/1p3n2/3p4/3P1B2/1QN1P3/PP3PPP/R3KB1R w KQ - 0 12",
        moves: "c3d5 f6d5 b3d5 e7b4",
        rating: 1199,
        themes: ["advantage", "opening", "short"],
        description: "Beginner Opening - Play as White (Rating: 1199)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'opening' as const
    },
    {
        fen: "r2qkb1r/1p1Npppp/p4n2/3p3b/Q7/2N1P3/PP1P1PPP/R1B1KB1R b KQkq - 0 9",
        moves: "d8d7 f1b5 a6b5 a4a8",
        rating: 1376,
        themes: ["crushing", "opening", "pin", "short"],
        description: "Intermediate Opening - Play as Black - Pin (Rating: 1376)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rnb1k2r/pppp1ppp/5q2/2b1p3/2B5/1QP2N2/PP1P1nPP/RNB2RK1 w kq - 0 7",
        moves: "f1f2 c5f2 g1f2 e5e4",
        rating: 1359,
        themes: ["crushing", "kingsideAttack", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1359)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1q2rk1/ppn1p1bp/2n1b1p1/1N2PpN1/8/6PP/PP3PBK/R1BQR3 b - - 4 16",
        moves: "c7b5 g5e6 c8e6 g2d5",
        rating: 1430,
        themes: ["advantage", "opening", "pin", "short"],
        description: "Intermediate Opening - Play as Black - Pin (Rating: 1430)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "2rqkb1r/pp1n1ppp/5n2/1B1P4/3p4/5Q2/PPPP1PPP/R1B2RK1 b k - 2 10",
        moves: "c8c2 f1e1 f8e7 d5d6",
        rating: 1725,
        themes: ["advantage", "opening", "pin", "short"],
        description: "Advanced Opening - Play as Black - Pin (Rating: 1725)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "rn1qk2r/pbp1ppbp/1p1p2p1/6B1/3PnQ2/5NP1/PPP1PPBP/RN3RK1 b kq - 5 8",
        moves: "e4g5 f3g5 b7g2 f4f7",
        rating: 1407,
        themes: ["advantage", "attackingF2F7", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1407)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b1k2r/ppp1qpp1/8/4p2p/3P2n1/5Q1P/PPP2PPb/RNB1RB1K w kq - 0 15",
        moves: "h3g4 h5g4 f1b5 c7c6",
        rating: 1734,
        themes: ["advantage", "opening", "short"],
        description: "Advanced Opening - Play as White (Rating: 1734)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bq1rk1/ppp2ppp/2nbp3/8/3P4/2PB1Q1N/P1P2PPP/R1B1K2R b KQ - 2 9",
        moves: "c6e7 d3h7 g8h7 f3h5 h7g8 h3g5",
        rating: 1704,
        themes: ["attraction", "crushing", "kingsideAttack", "long", "opening", "sacrifice"],
        description: "Advanced Opening - Play as Black (Rating: 1704)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b1kb1r/pp2pppp/5n2/q1pP4/3P4/2NQ4/PPP2PPP/R3KBNR b KQkq - 0 7",
        moves: "f6d5 d3b5 a5b5 f1b5",
        rating: 1634,
        themes: ["crushing", "master", "opening", "short"],
        description: "Advanced Opening - Play as Black (Rating: 1634)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r2q1rk1/pp3ppp/2nbb3/3n4/3P1P2/2N2N2/PP2B1PP/R1BQ1RK1 b - - 4 11",
        moves: "d5f4 c1f4 d6f4 d4d5 d8b6 g1h1",
        rating: 1706,
        themes: ["advantage", "defensiveMove", "fork", "long", "opening"],
        description: "Advanced Opening - Play as Black - Fork (Rating: 1706)",
        hint: "Attack multiple pieces at once!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bq1rk1/1p1pppbp/p1N3p1/3N4/4n3/4B3/PPP1BPPP/R2Q1RK1 b - - 0 10",
        moves: "b7c6 e3b6 d8e8 d5c7",
        rating: 1659,
        themes: ["crushing", "opening", "short"],
        description: "Advanced Opening - Play as Black (Rating: 1659)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "rnbqr1k1/p1b1np1p/2p3pP/3p4/1P1PN3/P1Q1P3/1B3PP1/R3KBNR b KQ - 0 18",
        moves: "d5e4 d4d5 f7f6 c3f6 e7f5 f6h8 g8f7 h8h7",
        rating: 1538,
        themes: ["opening"],
        description: "Intermediate Opening - Play as Black (Rating: 1538)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b1k1r1/ppp1bp1p/7Q/3qp3/4n3/4B3/PPP3PP/3RKBNR b Kq - 1 12",
        moves: "d5a2 f1b5 c7c6 b5c6 b7c6 h6c6",
        rating: 1233,
        themes: ["crushing", "long", "opening"],
        description: "Intermediate Opening - Play as Black (Rating: 1233)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r2qk2r/ppp2pp1/2nb2bp/8/3Pn3/2P1P3/PPBN2PP/R1BQK2R w KQkq - 0 12",
        moves: "d2e4 g6e4 c2e4 d8h4",
        rating: 1724,
        themes: ["advantage", "opening", "short"],
        description: "Advanced Opening - Play as White (Rating: 1724)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bqk2r/pp2nppp/2n1p3/3pP3/1b6/2NB1N2/PP3PPP/R1BQ1RK1 b kq - 6 9",
        moves: "e8g8 d3h7 g8h7 f3g5 h7g8 d1h5",
        rating: 1497,
        themes: ["advantage", "attraction", "clearance", "kingsideAttack", "long", "opening", "sacrifice"],
        description: "Intermediate Opening - Play as Black (Rating: 1497)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b1kb1r/pp3ppp/2n1p3/q2p4/3P1B2/P3PN2/1P1n1PPP/R2QKB1R w KQkq - 0 10",
        moves: "d1d2 f8b4 a3b4 a5a1",
        rating: 1399,
        themes: ["advantage", "master", "masterVsMaster", "opening", "pin", "short"],
        description: "Intermediate Opening - Play as White - Pin (Rating: 1399)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r2q1rk1/pp1n1ppp/2p1pn2/8/Pb1P3N/2N1P3/1P1BbPPP/R2QR1K1 w - - 0 13",
        moves: "c3e2 b4d2 d1d2 f6e4",
        rating: 1352,
        themes: ["crushing", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1352)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b1kb1r/ppp3p1/2np1qNp/4p3/2B1P1n1/2N5/PPP2PPP/R1BQR1K1 w kq - 4 11",
        moves: "g6h8 f6f2 g1h1 f2h4 h2h3 g4f2",
        rating: 1783,
        themes: ["advantage", "kingsideAttack", "long", "opening"],
        description: "Advanced Opening - Play as White (Rating: 1783)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b1k1nr/pppp1ppp/5q2/4N3/2B5/2b5/PB3PPP/R2Q1RK1 b kq - 0 10",
        moves: "c3e5 b2e5 f6e5 f1e1",
        rating: 1599,
        themes: ["crushing", "opening", "pin", "short"],
        description: "Intermediate Opening - Play as Black - Pin (Rating: 1599)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rn1q1rk1/pb2bppB/1p2p3/3nP3/7P/2N2N2/PPP3P1/R1BQK2R b KQ - 0 12",
        moves: "g8h7 f3g5 h7g8 d1h5",
        rating: 1346,
        themes: ["clearance", "crushing", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1346)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rnb1k2r/ppp2pbp/3p1q2/8/2BPPBn1/7P/PPP3P1/RN1Q1RK1 w kq - 1 11",
        moves: "h3g4 f6d4 d1d4 g7d4",
        rating: 1058,
        themes: ["advantage", "fork", "opening", "short"],
        description: "Beginner Opening - Play as White - Fork (Rating: 1058)",
        hint: "Attack multiple pieces at once!",
        complexity: 'beginner' as const,
        category: 'opening' as const
    },
    {
        fen: "r3kbnr/pp3ppp/2n1p3/q2p4/3P1Bb1/P1PB1N2/1P3PPP/RN1QK2R b KQkq - 2 8",
        moves: "c6d4 b2b4 d4f3 g2f3",
        rating: 1720,
        themes: ["advantage", "opening", "short"],
        description: "Advanced Opening - Play as Black (Rating: 1720)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "3qkb1r/pQr1nppp/1n4b1/8/2BPpB2/8/PP3PPP/R3K1NR w KQk - 0 12",
        moves: "b7c7 d8c7 f4c7 b6c4",
        rating: 1455,
        themes: ["advantage", "capturingDefender", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1455)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rn1qk2r/1bp2pb1/pp2p1pp/4Nn2/3PN3/3BB3/PPP2PPP/R2Q1RK1 b kq - 2 12",
        moves: "f5d4 e3d4 d8d4 d3b5",
        rating: 1472,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1472)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rnbqk2r/ppp2ppp/8/2bnP3/3p4/3B1N2/PPP3PP/RNBQ1RK1 b kq - 2 8",
        moves: "e8g8 d3h7 g8h7 f3g5 h7g8 d1h5",
        rating: 1610,
        themes: ["advantage", "attraction", "clearance", "kingsideAttack", "long", "opening", "sacrifice"],
        description: "Advanced Opening - Play as Black (Rating: 1610)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bqk2r/1p1nbppp/p1np4/3Np1P1/4P3/1N6/PPP1BP1P/R1BQK2R b KQkq - 2 10",
        moves: "e7g5 c1g5 d8g5 d5c7",
        rating: 1271,
        themes: ["crushing", "master", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1271)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bq1rk1/ppp2p2/3p4/3np1B1/2BnP3/P2P4/1PP2bPP/R2Q1K1R w - - 0 13",
        moves: "g5d8 d5e3 f1f2 e3d1",
        rating: 882,
        themes: ["advantage", "fork", "opening", "short"],
        description: "Beginner Opening - Play as White - Fork (Rating: 882)",
        hint: "Attack multiple pieces at once!",
        complexity: 'beginner' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bq1rk1/ppp3bN/2np1pp1/8/2PP4/2NB4/PP4PP/R1BQ2K1 b - - 0 11",
        moves: "g8h7 d1h5 h7g8 d3g6",
        rating: 1543,
        themes: ["crushing", "deflection", "opening", "pin", "short"],
        description: "Intermediate Opening - Play as Black - Pin (Rating: 1543)",
        hint: "Pin the opponent's piece!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bqk2r/pp1nppb1/2p4p/4p1P1/2B5/2N3P1/PPP3P1/R2QK1NR b KQkq - 0 14",
        moves: "h6g5 h1h8 g7h8 d1h5",
        rating: 1414,
        themes: ["crushing", "master", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1414)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rnb1k2r/1p3ppp/p7/3p4/1bq1n3/2N2P2/PPP1Q1PP/R1B1KB1R w KQkq - 0 11",
        moves: "f3e4 b4c3 b2c3 c4c3",
        rating: 1107,
        themes: ["crushing", "opening", "short"],
        description: "Beginner Opening - Play as White (Rating: 1107)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b1qr2/p1p2pk1/1bpp4/4P1BQ/3PnP2/7P/PP4P1/RN3RK1 b - - 2 16",
        moves: "f8h8 g5f6 e4f6 e5f6 g7f6 h5g5 f6e6 f1e1",
        rating: 1579,
        themes: ["advantage", "attraction", "master", "opening", "veryLong"],
        description: "Intermediate Opening - Play as Black (Rating: 1579)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bq1rk1/pp2bppp/2n1p2B/4P3/3P4/5N2/P1B2PPP/R2Q1RK1 b - - 2 13",
        moves: "g7h6 d1d3 f7f5 e5f6",
        rating: 1533,
        themes: ["advantage", "enPassant", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1533)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "3rkb1r/p1qb1ppp/2p1p3/3n4/B2Q4/2P1B3/PP3PPP/RN3RK1 w k - 3 13",
        moves: "d4a7 c7a7 e3a7 d8a8",
        rating: 1579,
        themes: ["crushing", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1579)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rnbqkb1r/1p1n1ppp/p3P3/1Bpp2N1/3p4/8/PPP2PPP/RNBQK2R b KQkq - 0 8",
        moves: "a6b5 e6f7 e8e7 d1e2",
        rating: 1385,
        themes: ["advancedPawn", "advantage", "attackingF2F7", "master", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1385)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bqr1n1/pp4bk/2n3pp/2pp1pB1/7P/2PP1NP1/PP3PB1/R2QRNK1 b - - 2 15",
        moves: "h6g5 f3g5 h7h8 g5f7",
        rating: 1065,
        themes: ["advantage", "opening", "short"],
        description: "Beginner Opening - Play as Black (Rating: 1065)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'beginner' as const,
        category: 'opening' as const
    },
    {
        fen: "r3kb1r/pp1n1ppp/1q2p3/3pPb1B/3p2P1/2P5/PP2Q1PP/RNB2RK1 w kq - 0 14",
        moves: "g4f5 d4d3 e2f2 f8c5",
        rating: 1604,
        themes: ["advantage", "discoveredAttack", "discoveredCheck", "opening", "pin", "short"],
        description: "Advanced Opening - Play as White - Pin (Rating: 1604)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b1k2r/ppq2ppp/2pB1n2/8/2n1P3/2N2N2/PP2K1PP/R2Q1B1R b kq - 0 11",
        moves: "c7d6 d1d6 c4d6 e4e5",
        rating: 1446,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1446)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rnbqkb1r/ppp2p2/3p4/3P2pn/2BQPp2/5N2/PPP1N1P1/R1B1K2R b KQkq - 1 11",
        moves: "f8g7 d4g7 h5g7 h1h8",
        rating: 1684,
        themes: ["advantage", "capturingDefender", "opening", "short"],
        description: "Advanced Opening - Play as Black (Rating: 1684)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r3kbnr/ppp2ppp/3p1q2/4N3/4P1b1/2Pp4/PP1NBPPP/R1BQ1RK1 b kq - 0 9",
        moves: "g4e2 d1a4 c7c6 e5c6",
        rating: 1644,
        themes: ["advantage", "opening", "short"],
        description: "Advanced Opening - Play as Black (Rating: 1644)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "1r1qkb1r/ppp1pppp/2n2n2/1Q3bB1/3Pp3/2N5/PPP2PPP/R3KBNR w KQk - 8 7",
        moves: "b5f5 c6d4 f1b5 c7c6",
        rating: 1563,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1563)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rnb2rk1/3nqppp/3bp3/pp1pN3/2pP4/PPP1P1B1/2BN1PPP/R2QK2R b KQ - 0 12",
        moves: "f7f6 c2h7 g8h7 d1h5 h7g8 e5g6",
        rating: 1520,
        themes: ["attraction", "crushing", "kingsideAttack", "long", "opening", "sacrifice"],
        description: "Intermediate Opening - Play as Black (Rating: 1520)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r2q1rk1/pp1n1ppp/2n1p3/2bpP3/8/1PNP1N2/PB3PPP/R2Q1RK1 b - - 0 12",
        moves: "d7e5 f3e5 c6e5 d3d4",
        rating: 1775,
        themes: ["advantage", "opening", "short"],
        description: "Advanced Opening - Play as Black (Rating: 1775)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bq1rk1/pp3ppp/2n5/8/2B5/2b2N2/P1P1QPPP/1RB2RK1 b - - 1 12",
        moves: "f8e8 c4f7 g8f7 e2c4",
        rating: 1591,
        themes: ["attraction", "crushing", "kingsideAttack", "opening", "sacrifice", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1591)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rnb1k2r/pp3p1p/6p1/q7/5P1b/2N3n1/PPPB3P/R2QKBNR w KQkq - 0 10",
        moves: "h2g3 h4g3 e1e2 c8g4",
        rating: 1287,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as White (Rating: 1287)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rn2kb1r/1Qpq1ppp/p3pn2/8/R2P4/4P3/1B3PPP/1N2K1NR b Kkq - 1 11",
        moves: "d7a4 b7c8 e8e7 b2a3",
        rating: 1728,
        themes: ["advantage", "opening", "short"],
        description: "Advanced Opening - Play as Black (Rating: 1728)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r1b2rk1/pp1n2pp/2pp4/2b4n/4P3/2N2NP1/PPP2PBP/R1B2RK1 w - - 2 13",
        moves: "f1e1 d7e5 f3e5 c5f2",
        rating: 1694,
        themes: ["advantage", "kingsideAttack", "opening", "sacrifice", "short"],
        description: "Advanced Opening - Play as White (Rating: 1694)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    },
    {
        fen: "r2q1rk1/pb1nbppp/1p2pn2/2ppN3/3P1P2/2PBPR2/PP1N2PP/R1BQ2K1 b - - 3 10",
        moves: "f6e8 d3h7 g8h7 f3h3 h7g8 d1h5",
        rating: 1364,
        themes: ["attraction", "clearance", "crushing", "kingsideAttack", "long", "opening", "sacrifice"],
        description: "Intermediate Opening - Play as Black (Rating: 1364)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r1bqk2r/ppp2p1p/3p1bPQ/4n3/4P3/2N2P2/PPP3P1/R3KBNR b KQkq - 0 13",
        moves: "h7g6 h6h8 f6h8 h1h8",
        rating: 1481,
        themes: ["advantage", "opening", "short"],
        description: "Intermediate Opening - Play as Black (Rating: 1481)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "r2qkbnr/1pp2pp1/p3p3/3pn3/3P1Bp1/4P3/PPPNBPP1/R2Q1RK1 w kq - 0 11",
        moves: "f4e5 d8h4 f2f3 g4g3 e5g3 h4g3",
        rating: 1585,
        themes: ["crushing", "long", "opening"],
        description: "Intermediate Opening - Play as White (Rating: 1585)",
        hint: "Find the best move that wins material or delivers checkmate!",
        complexity: 'intermediate' as const,
        category: 'opening' as const
    },
    {
        fen: "rnbq1b1r/pppp2k1/5np1/4p3/8/3P2Q1/PPP2PPP/RNB1KBNR w KQ - 0 8",
        moves: "g3e5 f8b4 c2c3 h8e8",
        rating: 1679,
        themes: ["advantage", "clearance", "opening", "pin", "short"],
        description: "Advanced Opening - Play as White - Pin (Rating: 1679)",
        hint: "Pin the opponent's piece!",
        complexity: 'advanced' as const,
        category: 'opening' as const
    }
];
